// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T16:19:54.202Z
// Property: Village at Mill Creek (ID: 6737460151191773)
// Collections: 24 amenities, 5 floorplans (live), 41 photos, 76 POIs, 4 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191773",
  "property_external_id": "5026484",
  "property_zillow_url": "https://www.zillow.com/b/552-e-main-st-statesboro-ga-5XrzJ3/",
  "property_apartments_url": "https://www.apartments.com/village-at-mill-creek-statesboro-ga/2eker7b",
  "property_google_business_url": "https://www.google.com/maps/place/Village+at+Mill+Creek/data=!4m2!3m1!1s0x0:0x92884e0ba5b9c7d5?sa=X&ved=2ahUKEwjFsLrwwLySAxV-RjABHUjdIqwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321108749",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "village-at-mill-creek",
  "property_name": "Village at Mill Creek",
  "property_website_url": "https://www.villagemillcreek.com/",
  "property_domain": "https://www.villagemillcreek.com/",
  "property_address": "552 E Main St",
  "property_full_address": "552 E Main St, Statesboro, GA 30461",
  "property_address_1": "552 E Main St",
  "property_address_2": null,
  "property_address_city": "Statesboro",
  "property_address_state": "GA",
  "property_address_zip_full": "30461-4223",
  "property_address_zip": "30461",
  "property_address_country": "US",
  "property_address_county": "Bulloch County",
  "property_neighborhood_address": "Georgia South Area",
  "property_address_latitude": "32.4524106",
  "property_address_longitude": "-81.7523808",
  "property_email": "villagemillcreek@rreafresidential.com",
  "property_phone": "(912) 489-3044",
  "property_call_tracking_phone": "409-405-6129",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Village at Mill Creek in Statesboro, GA, where modern living meets unparalleled comfort. Choose from spacious two and three-bedroom floor plans, and enjoy exceptional amenities like our sparkling pools, fitness center, and dog park. Experience the perfect blend of relaxation and recreation—your new home awaits!",
  "property_long_description": "Welcome to the Village at Mill Creek, your ideal apartment community in Statesboro, GA! Explore spacious and thoughtfully designed two and three-bedroom floor plans that cater to your lifestyle. Equipped with an array of top-notch amenities, our community offers the perfect blend of comfort and convenience.\n\nEnjoy outdoor gatherings at our community gas grill and fire pit, or unwind in our inviting clubhouse. Stay active with our 24-hour fitness center, basketball court, and access to the scenic Vulcan Trail for walking or jogging. With two sparkling swimming pools and a well-maintained dog park, there's something for everyone in your family—fur babies included!\n\nYour safety and comfort are our priorities, with controlled building access, ample covered parking, and 24-hour on-call maintenance and management to address your needs anytime. For those who work from home, our business center and conference room are equipped with the latest technology to help you stay productive.\n\nWe understand how important convenience is, which is why we offer amenities like car wash stations, clothes care centers, and playgrounds for children. Rest easy knowing our community is gated and monitored by a courtesy officer to ensure your peace of mind.\n\nDon't miss out on the perfect blend of luxury and practicality. Find your new home today—browse our availability or schedule a tour to experience the Village at Mill Creek firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-7f06-748f-8288-5124202bc36e.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019e84a9-7f06-748f-8288-5124202bc36e",
    "storage_key": "property/6737460151191773/019e84a9-7f06-748f-8288-5124202bc36e.webp",
    "width": 3072,
    "height": 2302
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "208",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.59615384615384",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Maximum 2 pets per home, 75 lb weight limit.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://villageatmillcreek.loftliving.com/login",
  "property_apply_now_url": "https://8921445.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-430c-71c2-8f83-0fdfef40d3cd.webp",
  "property_primary_logo_media": {
    "alt_text": "Village at Mill Creek Apartment Homes logo",
    "public_id": "019e84a9-430c-71c2-8f83-0fdfef40d3cd",
    "storage_key": "property/6737460151191773/019e84a9-430c-71c2-8f83-0fdfef40d3cd.webp",
    "width": 1463,
    "height": 263
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-92ad-7562-acc2-dce2ec196edd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Village at Mill Creek Apartment Homes logo",
    "public_id": "019e1e18-92ad-7562-acc2-dce2ec196edd",
    "storage_key": "property/6737460151191773/019e1e18-92ad-7562-acc2-dce2ec196edd.webp",
    "width": 351,
    "height": 63
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e8e87-7415-72fc-be5b-e40ca8e501a4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-7415-72fc-be5b-e40ca8e501a4",
    "storage_key": "property/6737460151191773/019e8e87-7415-72fc-be5b-e40ca8e501a4.webp",
    "width": 1280,
    "height": 230
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e8e87-688a-77df-a86b-37385bdb3bd4.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-688a-77df-a86b-37385bdb3bd4",
    "storage_key": "property/6737460151191773/019e8e87-688a-77df-a86b-37385bdb3bd4.webp",
    "width": 1280,
    "height": 230
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "970 - 1530",
  "property_sqft_min": "970",
  "property_sqft_max": "1530",
  "property_price_range": "1275 - 1925",
  "property_price_min": "1275",
  "property_price_max": "1925",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/people/Village-at-Mill-Creek/61554523052031/",
  "property_instagram_url": "https://www.instagram.com/village_at_mill_creek_rrliving",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZet2x544-ogR1ce5pQtOiJI",
  "property_youtube_url": "https://www.youtube.com/watch?t=299&v=lijVrfUZLek",
  "property_yelp_url": "https://www.yelp.com/biz/mill-creek-regional-park-statesboro",
  "property_tiktok_url": "https://www.tiktok.com/@village.at.mill.creek",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Village at Mill Creek",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Discover luxurious townhomes and <a href=\"/floor-plans/\">apartments</a> at Village At Mill Creek. Ideally located in Statesboro, GA, you can enjoy and explore the Georgia Southern University Museum. Our eclectic downtown offers residents a vast array of shopping, entertainment, and dining options.</p>",
  "property_home_floorplans_blurb": "<p>Looking for a fancy restaurant or exclusive shopping? Take a look around your new neighborhood and find something grand for everyone in Village at Mill Creek in Statesboro, GA. Living here means you will be surrounded by hotspots, exclusive restaurants, and shopping centers.</p>",
  "property_home_gallery_blurb": "Welcome to Village at Mill Creek in Statesboro, GA, where comfort and community collide. Choose from spacious two or three-bedroom floor plans, featuring modern amenities like a fitness center, pool, and pet play area. Picture yourself unwinding on your private balcony while enjoying our vibrant picnic area and gas fire pit!",
  "property_home_neighborhood_blurb": "At Village at Mill Creek in Statesboro, GA, our two- and three-bedroom floor plans offer comfort and style. Nestled in a vibrant neighborhood, you'll find local gems and popular destinations just a stone's throw away. Uncover the perfect blend of modern living and community charm right at your doorstep!",
  "property_home_reviews_blurb": "At Village at Mill Creek in Statesboro, GA, residents thrive in comfort and community. With glowing praise like, “Everyone here is nice and the place is quiet,” our inviting apartments and attentive staff create a welcoming atmosphere. Experience the joy of living where neighbors become friends. Check out our reviews!",
  "property_neighborhood_blurb": "<p>Looking for a fancy restaurant or exclusive shopping? Take a look around your new neighborhood and find something grand for everyone in Village at Mill Creek in Statesboro, GA. Living here means you will be surrounded by hotspots, exclusive restaurants, and shopping centers.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We offer residents superb community amenities, and our outstanding professional management team promise to be the best in the industry. Contact our Village At Mill Creek in <a href=\"/neighborhood/\">Statesboro, Georgia</a>, today to live in this remarkable community!</p>",
  "property_applynow_blurb": "At Village at Mill Creek in Statesboro, GA, your perfect home awaits! Choose from spacious two and three-bedroom floor plans while enjoying amenities like a gas fire pit, two sparkling pools, and a state-of-the-art 24-hour fitness center. Apply now and lease online to elevate your lifestyle!",
  "property_contactus_blurb": "At Village at Mill Creek in Statesboro, GA, spacious two and three-bedroom floor plans await you! Experience the perfect blend of comfort and community. Whether you’re looking for the ideal space or have questions, our leasing team is ready to help. Connect with us today!",
  "property_faqs_blurb": "At Village at Mill Creek in Statesboro, GA, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community and amenities. Your ideal home is just a click away!",
  "property_floorplans_blurb": "<p>Our exclusive townhomes and apartments for rent are designed with the <a href=\"/amenities/\">amenities</a> you deserve, such as vaulted ceilings and hardwood floors. We welcome pets and want you to bring your furry companions along to enjoy your exquisite townhome or apartment! Exquisite interiors provide endless comfort and satisfaction to your everyday life.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Village at Mill Creek in Statesboro, GA, choose from spacious two- and three-bedroom floor plans and indulge in exceptional amenities. Enjoy serene evenings by the gas fire pit, invigorate your workouts in our 24-hour fitness center, or unwind in one of our sparkling pools. Start your journey today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Village at Mill Creek in Statesboro, GA, our spacious two and three-bedroom floor plans are perfect for you and your friends to create lasting memories. Share the joy of upscale living by referring a friend today—great friends make great neighbors! Embrace community, comfort, and connection right here.",
  "property_residentaccess_blurb": "Welcome to the Village at Mill Creek in Statesboro, GA – where comfort meets convenience. With spacious two and three-bedroom floor plans, our community is designed for your lifestyle. Log in to your resident portal to effortlessly pay rent, schedule maintenance, and access exclusive community features today!",
  "property_reviews_blurb": "At Village at Mill Creek in Statesboro, GA, residents rave about their comfortable homes and attentive staff. One resident notes, “It is such a wonderful place to live; I highly recommend this to anybody that wants quiet, comfortable living.\" Experience the charm and community spirit that keeps our residents returning!",
  "property_created_at": "1752257095790",
  "property_scheduletour_blurb": "At Village at Mill Creek in Statesboro, GA, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and hear firsthand why our residents love being part of this vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Village at Mill Creek in Statesboro, GA! Our spacious two and three-bedroom floor plans offer a perfect blend of comfort and style. We can't wait to connect and help you find your ideal apartment. Stay tuned for our team’s prompt response!",
  "property_virtualtours_blurb": "Welcome to Village at Mill Creek in Statesboro, GA, where spacious two and three-bedroom floor plans await you. Immerse yourself in our community's vibrant atmosphere—take a virtual tour today and envision your new lifestyle in these stylish apartments designed for comfort and convenience! ",
  "property_copyright": "2025 All Rights Reserved. Village at Mill Creek",
  "property_seo_title_home": "Village at Mill Creek | Apartments in Statesboro, GA",
  "property_seo_description_home": "Welcome to Village at Mill Creek in Statesboro, GA, where modern living meets unparalleled convenience. Choose from spacious two- and three-bedroom apartments designed for your lifestyle. Enjoy a wealth of amenities, including two sparkling pools, a state-of-the-art fitness center, a dog park, and a vibrant clubroom perfect for social gatherings. With 24/7 maintenance and on-call management, your comfort is our priority. Discover the perfect blend of relaxation and recreation—it's time to find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 3 Apartments in Statesboro, GA",
  "property_seo_description_floorplans": "Unlock the potential of living at Village at Mill Creek in Statesboro, GA! Our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle needs. Each layout offers a blend of comfort and style—ideal for starting fresh or settling in. Browse our available apartment homes now and find the perfect fit for your next chapter!",
  "property_seo_title_amenities": "Amenities | Statesboro, GA Apartments for Rent",
  "property_seo_description_amenities": "\"Unwind in luxury at Village at Mill Creek in Statesboro, GA! Enjoy spacious two and three-bedroom floor plans alongside a wealth of amenities including two shimmering pools, a state-of-the-art fitness center, and a vibrant dog park. Our gated community features gas grills for weekend cookouts, a cozy clubroom for gatherings, and convenient covered parking. With 24/7 on-call maintenance and management, your comfort is our priority. Elevate your lifestyle as you access the scenic Vulcan trail right from your doorstep. Join us and experience community living redefined!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Statesboro, GA",
  "property_seo_description_gallery": "\"Step into the vibrant lifestyle at Village at Mill Creek in Statesboro, GA, where comfort meets community. Picture yourself enjoying spacious two and three-bedroom apartments surrounded by top-notch amenities, from relaxing by the gas fire pit to energizing workouts in our 24-hour fitness center. Dive into leisure with two sparkling pools, a lively dog park, and direct access to the scenic Vulcan Trail. Our gated community offers convenience with ample parking, business center resources, and on-call maintenance. Imagine every moment made memorable!📸\"",
  "property_seo_title_virtualtours": "Virtual Tours | Village at Mill Creek Apartments",
  "property_seo_description_virtualtours": "Step into your dream home at Village at Mill Creek in Statesboro, GA! Our virtual tour showcases spacious two and three-bedroom apartments designed for comfort and style. Experience the vibrant community lifestyle and find your perfect fit—ready to take the first step towards your new home? ",
  "property_seo_title_interactivemap": "Interactive Map | Village at Mill Creek Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Village at Mill Creek in Statesboro, GA! With spacious two and three-bedroom floor plans and a wide array of top-notch amenities including gas grills, a state-of-the-art fitness center, and a dog park, enjoy life in a thriving gated community. Unwind by the sparkling pools or gather with friends in the clubroom. Plus, with 24/7 maintenance and a convenient interactive map, finding your new apartment has never been easier. Dive into a vibrant lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Statesboro, GA",
  "property_seo_description_neighborhood": "Experience life at Village at Mill Creek in Statesboro, GA, where vibrant two and three-bedroom apartments meet a thriving neighborhood. Uncover local favorites and hidden gems just around the corner—from trendy cafes to scenic parks. Dive into the charm of our community and see what makes it a perfect place to call home!",
  "property_seo_title_contact": "Contact Us | Village at Mill Creek",
  "property_seo_description_contact": "Experience the charm of Village at Mill Creek in Statesboro, GA, where your dream home awaits! Our spacious two and three-bedroom floor plans cater to your lifestyle and comfort needs. Curious about availability or amenities? Our friendly leasing team is ready to assist you with any inquiries. Reach out today and let’s make your next move unforgettable!",
  "property_seo_title_faqs": "FAQs | Apartments in Statesboro, GA",
  "property_seo_description_faqs": "\"At Village at Mill Creek in Statesboro, GA, find your perfect home from our spacious two or three-bedroom floor plans. Enjoy a wealth of community amenities, including two sparkling pools, a 24-hour fitness center, and a dog park. Have questions? Our FAQs page has answers! Uncover the lifestyle you've been dreaming of—where comfort meets convenience.\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Statesboro, GA",
  "property_seo_description_reviews": "\"Experience the vibrant lifestyle at Village at Mill Creek in Statesboro, GA. With spacious two and three-bedroom floor plans, our community offers exceptional amenities including 24-hour fitness and business centers, beautiful pools, and a dog park. Feel secure in our gated environment, where convenience meets comfort. Don't just take our word for it—see what our residents are saying about their home sweet home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Statesboro, GA",
  "property_seo_description_applynow": "Experience life at Village at Mill Creek, where comfort meets convenience in beautiful Statesboro, GA. Choose from spacious two and three-bedroom floor plans, and enjoy top-tier amenities like 24-hour fitness centers, gas grills, and a serene dog park. Relax by one of our two sparkling pools or unwind around the gas fire pit—your perfect community awaits! With covered parking, on-call maintenance, and direct access to the Vulcan trail, you'll find everything you need right at your doorstep. Secure your dream home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Village at Mill Creek",
  "property_seo_description_residentaccess": "\"Unlock seamless living at Village at Mill Creek in Statesboro, GA! Access your personalized resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with your vibrant community. Your convenience starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Village at Mill Creek",
  "property_seo_description_referafriend": "\"Share the joy of community living at Village at Mill Creek in Statesboro, GA! Refer a friend today and enjoy exclusive perks while building connections that make your apartment feel like home. Great friends make great neighbors—let’s grow our vibrant community together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Village at Mill Creek",
  "property_seo_description_scheduletour": "\"Experience the charm of Village at Mill Creek in Statesboro, GA—a vibrant apartment community infused with modern comforts and serene surroundings. Ready to find your perfect home? Schedule a tour today and step into your future!\"",
  "property_seo_title_privacy": "Privacy Policy | Village at Mill Creek",
  "property_seo_description_privacy": "\"At Village at Mill Creek in Statesboro, GA, your peace of mind is our priority. Dive into our privacy policy to see how we safeguard your information while you enjoy the comforts of home. Transparency is key—learn more about our commitment to your privacy today.\"",
  "property_seo_title_accessibility": "Website Accessibility | Village at Mill Creek",
  "property_seo_description_accessibility": "\"At Village at Mill Creek in Statesboro, GA, we prioritize digital accessibility for all. Our commitment to inclusivity ensures everyone can navigate our community online with ease. Join us in creating a welcoming environment for everyone—and let’s bridge the gap together.\"",
  "property_seo_title_sitemap": "Sitemap | Village at Mill Creek",
  "property_seo_description_sitemap": "Unravel the charm of Village at Mill Creek in Statesboro, GA. Navigate effortlessly through our comprehensive sitemap to find your dream apartment, facilities, and community highlights. Your ideal living experience awaits!",
  "property_seo_title_thankyou": "Thank You | Village at Mill Creek",
  "property_seo_description_thankyou": "Thank you for reaching out to Village at Mill Creek in Statesboro, GA! Your interest brings you closer to a vibrant community where comfort meets convenience. Our team is excited to assist you on your journey to finding the perfect home. Expect to hear from us soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Statesboro, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293614904",
  "amenities": [
    {
      "id": "ec_876f9eacbb241948771ff033",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2ed56aae1e17be5cb44cbbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b53d6ee1fe55dcf69b333cd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de3e7e67df86a9279a18916d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8014b8bcc3580ec3d1f5fd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97885eaecbe348aa9c33ee1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4fb5aac0be78b1cc4763760",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2107a9cb410694c158357536",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeted Floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7db7dc21545894278434b71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61d1bf317fd35951e2780b08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b34d5fda927164704e3a04a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Double Sink",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6551890455c695f10a9fc7ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Exterior Storage Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34b5fd09b91acac214ad8103",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Full Size Washer and Dryer in Each Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca5a39b78850c4831619d19c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d80f00e731c41f95b2d7a1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90646de81cd0353b4232ccf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_261694ea67d0fc407f2133c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Large Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_959e2f2b0a37a7d2215c7bb3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d8aa853c7d3eae742e1a5ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Open Concept Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a89ff2cb4e629608b868c922",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a3656e03da7b11afac262f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Side‑by‑Side Refrigerator*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30e729e7ff20f5645a9a21a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6315d5a6312c8a97bc91b2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0919db278607d97e38b22805",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3795e854-6f70-4aa4-b33e-131220e7af75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-7f06-748f-8288-5124202bc36e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e84a9-7f06-748f-8288-5124202bc36e",
        "storage_key": "property/6737460151191773/019e84a9-7f06-748f-8288-5124202bc36e.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05dce4e0-fcf5-49b9-9be7-39f0c014421f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-d5a3-72ab-91b9-2bafcd5f1067.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, accent chair, TV, and dining area.",
        "public_id": "019e84a9-d5a3-72ab-91b9-2bafcd5f1067",
        "storage_key": "property/6737460151191773/019e84a9-d5a3-72ab-91b9-2bafcd5f1067.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, stylish accent chair, and wall-mounted TV. Adjacent dining space is perfect for meals.",
      "link": "",
      "alt_text": "Living room with a sofa, accent chair, TV, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96fec306-c2a9-4fee-b7ed-227c17bb11af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-c164-742f-9d95-e1039ccd6753.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and wood-look flooring.",
        "public_id": "019e84a9-c164-742f-9d95-e1039ccd6753",
        "storage_key": "property/6737460151191773/019e84a9-c164-742f-9d95-e1039ccd6753.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bright and airy kitchen features sleek white cabinetry, a full suite of stainless steel appliances, and elegant granite countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_175dd1d3-2842-4241-9cee-a99ec86a7d75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-e170-7648-a093-b1d92c7a2e05.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with sofas, chairs, and a popcorn machine.",
        "public_id": "019e84a9-e170-7648-a093-b1d92c7a2e05",
        "storage_key": "property/6737460151191773/019e84a9-e170-7648-a093-b1d92c7a2e05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our modern community lounge, featuring comfortable seating and a fun popcorn machine for movie nights.",
      "link": "",
      "alt_text": "Stylish lounge area with sofas, chairs, and a popcorn machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03180a91-844e-4fd4-81b0-b3fb484447e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-c1ca-778a-a364-463c34c3f325.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, TV, dining table, and a large window.",
        "public_id": "019e84a9-c1ca-778a-a364-463c34c3f325",
        "storage_key": "property/6737460151191773/019e84a9-c1ca-778a-a364-463c34c3f325.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern and inviting living room featuring a comfortable sofa, a wall-mounted TV, a stylish dining area, and ample natural light from a large window.",
      "link": "",
      "alt_text": "Living room with a sofa, TV, dining table, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac79a142-033d-430f-bd9d-f31de4ebb5ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-d0f7-76bd-b0aa-571189cf545f.webp",
      "image_media": {
        "alt_text": "Dining room with round wooden table, four chairs, and a wall tapestry.",
        "public_id": "019e84a9-d0f7-76bd-b0aa-571189cf545f",
        "storage_key": "property/6737460151191773/019e84a9-d0f7-76bd-b0aa-571189cf545f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, featuring a round wooden table set for four, complemented by a stylish wall tapestry and ample natural light.",
      "link": "",
      "alt_text": "Dining room with round wooden table, four chairs, and a wall tapestry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1643abc2-4bf5-44e3-9281-ea367ef9dfea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-e982-71b8-aea2-35ae8c712b77.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating areas.",
        "public_id": "019e84a9-e982-71b8-aea2-35ae8c712b77",
        "storage_key": "property/6737460151191773/019e84a9-e982-71b8-aea2-35ae8c712b77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas perfect for relaxing.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8776b0fd-a2b5-46a2-9434-b9294041e333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-e950-73ba-bff1-c6bb59e2e1a6.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, weight machines, and free weights.",
        "public_id": "019e84a9-e950-73ba-bff1-c6bb59e2e1a6",
        "storage_key": "property/6737460151191773/019e84a9-e950-73ba-bff1-c6bb59e2e1a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring modern cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6b57eff-3a00-49aa-b213-a6d2eadd1b9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-e9bf-753e-8ba2-fe3ce89e8ded.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weightlifting equipment.",
        "public_id": "019e84a9-e9bf-753e-8ba2-fe3ce89e8ded",
        "storage_key": "property/6737460151191773/019e84a9-e9bf-753e-8ba2-fe3ce89e8ded.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weightlifting equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0abd43c1-d405-4e7e-9b7d-b05c939a8e8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-e9e5-732b-99b2-b67f4b98e077.webp",
      "image_media": {
        "alt_text": "Fitness center with weight rack, dumbbells, and stability balls.",
        "public_id": "019e84a9-e9e5-732b-99b2-b67f4b98e077",
        "storage_key": "property/6737460151191773/019e84a9-e9e5-732b-99b2-b67f4b98e077.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community fitness center is equipped with a variety of cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with weight rack, dumbbells, and stability balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a721e22-bc17-4f16-93d1-c87d330c4d78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-de65-76ae-a18c-e8c6d77f01d5.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue armchairs, a sofa, and decorative lighting.",
        "public_id": "019e84a9-de65-76ae-a18c-e8c6d77f01d5",
        "storage_key": "property/6737460151191773/019e84a9-de65-76ae-a18c-e8c6d77f01d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, perfect for socializing or quiet contemplation. Enjoy comfortable seating and ambient lighting in this inviting communal space.",
      "link": "",
      "alt_text": "Modern lounge area with blue armchairs, a sofa, and decorative lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a71d65b0-08f1-4bfa-902b-fdde952d9477",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-d89f-75de-9902-f3d0bc791ec4.webp",
      "image_media": {
        "alt_text": "Community lounge with coffee station and mini-fridge.",
        "public_id": "019e84a9-d89f-75de-9902-f3d0bc791ec4",
        "storage_key": "property/6737460151191773/019e84a9-d89f-75de-9902-f3d0bc791ec4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and beverages in our resident lounge.",
      "link": "",
      "alt_text": "Community lounge with coffee station and mini-fridge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a808e629-817f-47db-b265-03071462b953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b9f5-718f-8ff6-2c47c4a8ca2c.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, closet, and dresser.",
        "public_id": "019e84a9-b9f5-718f-8ff6-2c47c4a8ca2c",
        "storage_key": "property/6737460151191773/019e84a9-b9f5-718f-8ff6-2c47c4a8ca2c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, ample closet space, and a stylish dresser with decorative items.",
      "link": "",
      "alt_text": "Bedroom with a bed, closet, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7bccf3b5-748e-4b3e-aaa8-41da70fe0181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b6e8-723b-90e6-fbb189e9ec98.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and a large sink.",
        "public_id": "019e84a9-b6e8-723b-90e6-fbb189e9ec98",
        "storage_key": "property/6737460151191773/019e84a9-b6e8-723b-90e6-fbb189e9ec98.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this sleek, modern kitchen featuring pristine white cabinetry, granite countertops, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd5c2772-8c08-4124-8d5e-ee0682a8f2ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b12d-749e-a70e-009817a968cd.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with wash, dry, fold signs.",
        "public_id": "019e84a9-b12d-749e-a70e-009817a968cd",
        "storage_key": "property/6737460151191773/019e84a9-b12d-749e-a70e-009817a968cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with convenient shelving and decorative signs to make laundry day a breeze.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet with wash, dry, fold signs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35d780ad-ac70-4c4a-ad90-8db351f85598",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-ab4b-7776-a039-829a0963f7a3.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with multiple buildings, parking lots, and a swimming pool.",
        "public_id": "019e84a9-ab4b-7776-a039-829a0963f7a3",
        "storage_key": "property/6737460151191773/019e84a9-ab4b-7776-a039-829a0963f7a3.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Experience comfortable living in this spacious apartment community, featuring a refreshing swimming pool and convenient parking.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with multiple buildings, parking lots, and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_365d4981-aa10-467e-963e-d3f276c658ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b0b1-77ef-8838-7d744ffb1773.webp",
      "image_media": {
        "alt_text": "Kitchen, dining, and living area in an apartment unit.",
        "public_id": "019e84a9-b0b1-77ef-8838-7d744ffb1773",
        "storage_key": "property/6737460151191773/019e84a9-b0b1-77ef-8838-7d744ffb1773.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy open-concept living space featuring a modern kitchen, dining area, and comfortable living room, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen, dining, and living area in an apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ddef896-6086-45fb-a355-729fead46239",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b58f-703a-89e3-50491a59832f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e84a9-b58f-703a-89e3-50491a59832f",
        "storage_key": "property/6737460151191773/019e84a9-b58f-703a-89e3-50491a59832f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring sleek white cabinetry, a full suite of stainless steel appliances, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1582025c-0247-49e5-a9eb-c82b2f1fda51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-b26b-70b9-bb17-571870c91633.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and mirror.",
        "public_id": "019e84a9-b26b-70b9-bb17-571870c91633",
        "storage_key": "property/6737460151191773/019e84a9-b26b-70b9-bb17-571870c91633.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, elegant dresser with mirror, and decorative wall art.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11a7a190-5b84-4c9b-90f1-9d248e9491f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-9220-7635-b33f-5c874e4039b5.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, fire hydrant, and a small black dog.",
        "public_id": "019e84a9-9220-7635-b33f-5c874e4039b5",
        "storage_key": "property/6737460151191773/019e84a9-9220-7635-b33f-5c874e4039b5.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment, a tunnel, and a fire hydrant. A perfect place for your furry friend to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment, fire hydrant, and a small black dog.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ed7f98a-77f0-4cdf-a21b-53c4840cd28e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-9f98-7298-90ca-291bb52e8fb7.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, closet, and a private balcony.",
        "public_id": "019e84a9-9f98-7298-90ca-291bb52e8fb7",
        "storage_key": "property/6737460151191773/019e84a9-9f98-7298-90ca-291bb52e8fb7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, a ceiling fan for comfort, and a walk-in closet. Enjoy natural light from the balcony doors and windows.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, closet, and a private balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8144e812-a3f0-429d-abd9-e43e926fc204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-8339-7181-a75e-7ecca60b1e6d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and parking lots.",
        "public_id": "019e84a9-8339-7181-a75e-7ecca60b1e6d",
        "storage_key": "property/6737460151191773/019e84a9-8339-7181-a75e-7ecca60b1e6d.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring multiple buildings, a swimming pool, and ample parking. Enjoy comfortable living in this well-maintained community.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and parking lots.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e9a82ddc-924f-4224-96a8-00bbba18c8eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-8659-73d9-b77f-09e861707b28.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a white wood bed with blue and white patterned bedding, a ceiling fan, and artwork on the wall.",
        "public_id": "019e84a9-8659-73d9-b77f-09e861707b28",
        "storage_key": "property/6737460151191773/019e84a9-8659-73d9-b77f-09e861707b28.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, complete with a plush bed and stylish decor. Perfect for restful nights.",
      "link": "",
      "alt_text": "A bedroom featuring a white wood bed with blue and white patterned bedding, a ceiling fan, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb08e692-260d-43ab-b0ef-3e9e3c32e5bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-8ff6-72bd-89a4-200faea616fb.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment like ramps and jumps.",
        "public_id": "019e84a9-8ff6-72bd-89a4-200faea616fb",
        "storage_key": "property/6737460151191773/019e84a9-8ff6-72bd-89a4-200faea616fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with fun agility equipment for your furry friends to play on. A great space for pets to exercise and socialize.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment like ramps and jumps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8eb25c2-1cd7-4be6-8148-c13583612c39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-74db-73f8-bf04-1be2f4d3fdff.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and a clubhouse.",
        "public_id": "019e84a9-74db-73f8-bf04-1be2f4d3fdff",
        "storage_key": "property/6737460151191773/019e84a9-74db-73f8-bf04-1be2f4d3fdff.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on sunny days. Surrounded by comfortable lounge chairs and a shaded cabana, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e5a73da-973a-4e50-9a36-195de122c81b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-7ac8-756f-8942-fdc09692b4f8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex pool and clubhouse area with surrounding buildings and trees.",
        "public_id": "019e84a9-7ac8-756f-8942-fdc09692b4f8",
        "storage_key": "property/6737460151191773/019e84a9-7ac8-756f-8942-fdc09692b4f8.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, perfect for relaxing on sunny days. The adjacent clubhouse provides a shaded area for gathering and unwinding.",
      "link": "",
      "alt_text": "Aerial view of apartment complex pool and clubhouse area with surrounding buildings and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a651983-34a7-43e9-ab84-0a658a224c4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-8300-7679-b27e-9bdfe034fcda.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings and parking lots.",
        "public_id": "019e84a9-8300-7679-b27e-9bdfe034fcda",
        "storage_key": "property/6737460151191773/019e84a9-8300-7679-b27e-9bdfe034fcda.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Discover our vibrant community with spacious apartment buildings and convenient parking, nestled in a scenic, tree-lined neighborhood.",
      "link": "",
      "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings and parking lots.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc36b46e-aed2-4855-a960-230d7fd02893",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-7e0d-72fc-a5e7-019295b94334.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and access to a bathroom.",
        "public_id": "019e84a9-7e0d-72fc-a5e7-019295b94334",
        "storage_key": "property/6737460151191773/019e84a9-7e0d-72fc-a5e7-019295b94334.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant dresser, and direct access to a private bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and access to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_565eb711-bb79-442f-a34d-e887a6cdde13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-37b9-703e-b382-c805b3191941.webp",
      "image_media": {
        "alt_text": "Spacious living room with wood-look flooring and a ceiling fan.",
        "public_id": "019e84a9-37b9-703e-b382-c805b3191941",
        "storage_key": "property/6737460151191773/019e84a9-37b9-703e-b382-c805b3191941.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "An open-concept living area featuring elegant wood-look flooring and a modern ceiling fan, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Spacious living room with wood-look flooring and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23e0f164-0f1d-4e1d-aa2c-7e61563bcdd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-371e-72b8-9465-bc1bea58c042.webp",
      "image_media": {
        "alt_text": "Living room with wood floors, blinds on windows, and a ceiling fan.",
        "public_id": "019e84a9-371e-72b8-9465-bc1bea58c042",
        "storage_key": "property/6737460151191773/019e84a9-371e-72b8-9465-bc1bea58c042.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious living room featuring wood-look flooring, large windows with blinds, and a ceiling fan. The room also includes a staircase leading to the upper level.",
      "link": "",
      "alt_text": "Living room with wood floors, blinds on windows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aac0a8e2-3081-46a6-a438-9343e2422b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-353f-7339-901d-d7ecbb6b20c0.webp",
      "image_media": {
        "alt_text": "Interior view of a walk-in closet with white shelves and door.",
        "public_id": "019e84a9-353f-7339-901d-d7ecbb6b20c0",
        "storage_key": "property/6737460151191773/019e84a9-353f-7339-901d-d7ecbb6b20c0.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in shelving and modern flooring.",
      "link": "",
      "alt_text": "Interior view of a walk-in closet with white shelves and door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5457a39-4cda-43da-95df-56a60743af02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-328d-71fc-9883-782a072676df.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a tray ceiling and ceiling fan.",
        "public_id": "019e84a9-328d-71fc-9883-782a072676df",
        "storage_key": "property/6737460151191773/019e84a9-328d-71fc-9883-782a072676df.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Generously sized bedroom featuring a tray ceiling with an elegant fan, plush carpeting, and ample closet space.",
      "link": "",
      "alt_text": "Spacious bedroom with a tray ceiling and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edcb5ff9-e56e-46b1-b0e6-c6dae73b30a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-320e-73cf-bbf7-4a94e74a79d5.webp",
      "image_media": {
        "alt_text": "Empty storage closet with white shelving",
        "public_id": "019e84a9-320e-73cf-bbf7-4a94e74a79d5",
        "storage_key": "property/6737460151191773/019e84a9-320e-73cf-bbf7-4a94e74a79d5.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious storage closet with multiple shelves for all your organizational needs.",
      "link": "",
      "alt_text": "Empty storage closet with white shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04a2b459-bfa1-4506-a516-7694c9150d5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-3149-754e-b1ec-c32ca84a8058.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a tray ceiling and ceiling fan.",
        "public_id": "019e84a9-3149-754e-b1ec-c32ca84a8058",
        "storage_key": "property/6737460151191773/019e84a9-3149-754e-b1ec-c32ca84a8058.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a tray ceiling, and a ceiling fan, offering a comfortable and serene living space.",
      "link": "",
      "alt_text": "Empty bedroom with a tray ceiling and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_867c61e7-3329-4e74-9398-8ecc96ee2aae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-20bc-7381-986e-497ac27b0ffb.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows, a ceiling fan, and carpeted floor.",
        "public_id": "019e84a9-20bc-7381-986e-497ac27b0ffb",
        "storage_key": "property/6737460151191773/019e84a9-20bc-7381-986e-497ac27b0ffb.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a ceiling fan, large windows with blinds, and plush carpeting. Perfect for a peaceful retreat.",
      "link": "",
      "alt_text": "Empty bedroom with two windows, a ceiling fan, and carpeted floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9f9c64f-9cd5-4969-96ef-eb4517277c6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-219d-70ac-bf26-33fdd07656c9.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet, white walls, ceiling fan, and blinds on the window.",
        "public_id": "019e84a9-219d-70ac-bf26-33fdd07656c9",
        "storage_key": "property/6737460151191773/019e84a9-219d-70ac-bf26-33fdd07656c9.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features plush carpeting, clean white walls, and a convenient ceiling fan. A large window with blinds allows for natural light.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet, white walls, ceiling fan, and blinds on the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e2be104-be80-424a-baf7-0cf6aa53396b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-21ea-763e-afbd-ed72c3a49164.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
        "public_id": "019e84a9-21ea-763e-afbd-ed72c3a49164",
        "storage_key": "property/6737460151191773/019e84a9-21ea-763e-afbd-ed72c3a49164.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, elegant granite countertops, and a full suite of modern black appliances. Perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7a2038c-6d60-43c3-8799-d67e12123c92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-2155-747e-8749-d6bbf279b790.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and two closets",
        "public_id": "019e84a9-2155-747e-8749-d6bbf279b790",
        "storage_key": "property/6737460151191773/019e84a9-2155-747e-8749-d6bbf279b790.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and ample closet space. Additional doorways lead to other rooms, offering a glimpse into the apartment's layout.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and two closets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6214c1b6-2776-46cc-bf75-1b3c00e51d06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-2049-7409-9da1-717236d6a817.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer.",
        "public_id": "019e84a9-2049-7409-9da1-717236d6a817",
        "storage_key": "property/6737460151191773/019e84a9-2049-7409-9da1-717236d6a817.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "In-unit washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4cc6c76-40e2-41d1-9f21-1f1ae9c1e594",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-20cf-7422-8056-6e4317e3c605.webp",
      "image_media": {
        "alt_text": "Interior view of a laundry closet with shelves and a washing machine.",
        "public_id": "019e84a9-20cf-7422-8056-6e4317e3c605",
        "storage_key": "property/6737460151191773/019e84a9-20cf-7422-8056-6e4317e3c605.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with ample storage space, featuring a washer and ample shelving for your convenience.",
      "link": "",
      "alt_text": "Interior view of a laundry closet with shelves and a washing machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c612597-60be-4ee9-81eb-4bf734c851c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e84a9-1f20-70c0-b312-c3d45f607026.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and carpet.",
        "public_id": "019e84a9-1f20-70c0-b312-c3d45f607026",
        "storage_key": "property/6737460151191773/019e84a9-1f20-70c0-b312-c3d45f607026.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving, perfect for organizing your belongings. Features plush carpeting and clean white walls.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2508622e-d105-4f6a-9348-f0a5e881880b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Cool Beanz Espresso Bar",
      "poi_type": "Restaurants",
      "poi_address": "19 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Coffee shop and roaster offering an array of coffees and a selection of teas, plus desserts and views of the town.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-b92d-732e-9769-c249592dfb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-b92d-732e-9769-c249592dfb4d",
        "storage_key": "property/6737460151191773/019e1e1a-b92d-732e-9769-c249592dfb4d.webp",
        "width": 828,
        "height": 621
      },
      "poi_business_url": "http://statesborocoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17707969055110500585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cool-beanz-espresso-bar",
      "poi_latitude": "32.4481463",
      "poi_longitude": "-81.78375030000001",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-421-9078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e77-700f-95e0-35f212bf3b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e77-700f-95e0-35f212bf3b52",
        "storage_key": "property/6737460151191773/019e1e1b-1e77-700f-95e0-35f212bf3b52.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJbbgMMc5B-ogR6ZB45whYv_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_45c4a551-d4e2-4436-9e53-14e10e7e6983",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Boro Bagel Company",
      "poi_type": "Restaurants",
      "poi_address": "23 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Casual restaurant serving New York-style bagels for breakfast and lunch, including vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-b87a-7359-8c53-ee48acec8418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-b87a-7359-8c53-ee48acec8418",
        "storage_key": "property/6737460151191773/019e1e1a-b87a-7359-8c53-ee48acec8418.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589840913577400909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boro-bagel-company",
      "poi_latitude": "32.4480753",
      "poi_longitude": "-81.78376449999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-259-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbbDK2xB-ogRTdqtGTSs9pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_8b839239-61bb-48fd-9090-6f9e642c94d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "D's Friendly Diner",
      "poi_type": "Restaurants",
      "poi_address": "503 Northside Dr E, Statesboro, GA 30458, USA",
      "poi_short_description": "Casual diner offering breakfast, lunch, and dinner, with outdoor seating, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-b9ea-721e-952d-627970ae741e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-b9ea-721e-952d-627970ae741e",
        "storage_key": "property/6737460151191773/019e1e1a-b9ea-721e-952d-627970ae741e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9013999770656106873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ds-friendly-diner",
      "poi_latitude": "32.4399683",
      "poi_longitude": "-81.7629948",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-764-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFffBBVtH-ogReelofwgpGH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_297ed6d0-9a5e-4246-b4b1-6bce3b79f98c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Antoinette Cafe Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "193 W Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Soul food eatery featuring fried chicken, fish, and mac 'n' cheese in a warm setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-ba45-7322-98ae-8d3ca2609035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-ba45-7322-98ae-8d3ca2609035",
        "storage_key": "property/6737460151191773/019e1e1a-ba45-7322-98ae-8d3ca2609035.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "http://www.antoinettecafekitchens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5876374033098378886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antoinette-cafe-kitchen",
      "poi_latitude": "32.4494129",
      "poi_longitude": "-81.7882352",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-225-0074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL250hVxB-ogRho4oegwTjVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "custom_f0eb4339-0d8f-4712-b57b-b74f7c471003",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Oak 45",
      "poi_type": "Restaurants",
      "poi_address": "45 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-bcb9-7060-9175-70bd0ea16f3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-bcb9-7060-9175-70bd0ea16f3b",
        "storage_key": "property/6737460151191773/019e1e1a-bcb9-7060-9175-70bd0ea16f3b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://oak45.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8063650797669550002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-45",
      "poi_latitude": "32.4490258",
      "poi_longitude": "-81.7818763",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e87-70ac-8b78-778e9c24e050.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e87-70ac-8b78-778e9c24e050",
        "storage_key": "property/6737460151191773/019e1e1b-1e87-70ac-8b78-778e9c24e050.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0tSXABB-ogRsofja63X528",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "custom_0feff66e-e4cd-495f-961c-54cccbf6fa18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Tandoor and Tap",
      "poi_type": "Restaurants",
      "poi_address": "40 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Warm, informal, family eatery featuring classic Indian fare including curries, tandoori dishes and naan breads and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-bd62-77de-9a3b-9e6d396673bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-bd62-77de-9a3b-9e6d396673bf",
        "storage_key": "property/6737460151191773/019e1e1a-bd62-77de-9a3b-9e6d396673bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tandoorandtap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7986738709428368007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tandoor-and-tap",
      "poi_latitude": "32.448628",
      "poi_longitude": "-81.78204869999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-259-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-fRuwRB-ogRh_JWaYqY1m4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_0a133877-c230-440a-90a4-69195aaba1df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bull and Barrel Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "30 W Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-5703-71b1-9864-f6aed2dd1142.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-5703-71b1-9864-f6aed2dd1142",
        "storage_key": "property/6737460151191773/019e1e18-5703-71b1-9864-f6aed2dd1142.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bullandbarrelga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10004901554532245857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bull-and-barrel-steakhouse",
      "poi_latitude": "32.4488493",
      "poi_longitude": "-81.7847383",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-259-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46YHBuVB-ogRYeGlovSM2Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d8540c2c-35c5-44d9-9bac-aad620cce8ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Huey's on Main",
      "poi_type": "Restaurants",
      "poi_address": "232 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-bb2f-75e7-a509-7c23f6eab43b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-bb2f-75e7-a509-7c23f6eab43b",
        "storage_key": "property/6737460151191773/019e1e1a-bb2f-75e7-a509-7c23f6eab43b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.hueysonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14616184984258166533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hueys-on-main",
      "poi_latitude": "32.4427448",
      "poi_longitude": "-81.7835703",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-259-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW2lylv9B-ogRBT8bps0e18o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_6d7ef425-6599-4513-80b2-9ce7db818d76",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Nonna Picci Wood Fired Pizza",
      "poi_type": "Restaurants",
      "poi_address": "807 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Pizza made in a wood-fired oven is the highlight at this casual spot with games and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-bea1-7218-967f-13feae19a690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-bea1-7218-967f-13feae19a690",
        "storage_key": "property/6737460151191773/019e1e1a-bea1-7218-967f-13feae19a690.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nonnapicci.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11579553085743850560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nonna-picci-wood-fired-pizza",
      "poi_latitude": "32.4233036",
      "poi_longitude": "-81.793099",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-681-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeaWiMZA-ogRQGSKLS7WsqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8b725705-97c1-418b-915a-6790280309c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Vandy's Bar-B-Q (Downtown)",
      "poi_type": "Restaurants",
      "poi_address": "22 W Vine St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-b892-76ba-b5e0-adc9956e517f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-b892-76ba-b5e0-adc9956e517f",
        "storage_key": "property/6737460151191773/019e1e1a-b892-76ba-b5e0-adc9956e517f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3058612209659237994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vandys-bar-b-q-downtown",
      "poi_latitude": "32.4481806",
      "poi_longitude": "-81.78457519999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7k5ialA-ogRalZpdplfcio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_7235c512-8c5f-4ca7-ba24-ffc9e352a054",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Seasons of Japan",
      "poi_type": "Restaurants",
      "poi_address": "430 Northside Dr E #142, Statesboro, GA 30458, USA",
      "poi_short_description": "Contemporary counter-serve eatery with a simple selection of hibachi-style Japanese fare & sushi.",
      "poi_long_description": "Contemporary counter-serve eatery with a simple selection of hibachi-style Japanese fare & sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c5f1-719e-a432-cbd013ef078b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c5f1-719e-a432-cbd013ef078b",
        "storage_key": "property/6737460151191773/019e1e1a-c5f1-719e-a432-cbd013ef078b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.seasonsofjapan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14380506943275005800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seasons-of-japan",
      "poi_latitude": "32.4387715",
      "poi_longitude": "-81.759602",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-764-5150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy85qy1xH-ogRaPfxq9_Skcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_f0b7fb43-a08a-4ddb-95a1-9087de901e39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Son's Döner Kebab",
      "poi_type": "Restaurants",
      "poi_address": "520 Fair Rd Suite 10, Statesboro, GA 30458, USA",
      "poi_short_description": "German-style döner kebabs, pitas, plates, specials & drinks in a relaxed space with outdoor tables.",
      "poi_long_description": "German-style döner kebabs, pitas, plates, specials & drinks in a relaxed space with outdoor tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-bf6b-76a6-a817-b896b80cf3d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-bf6b-76a6-a817-b896b80cf3d7",
        "storage_key": "property/6737460151191773/019e1e1a-bf6b-76a6-a817-b896b80cf3d7.webp",
        "width": 1202,
        "height": 1280
      },
      "poi_business_url": "https://www.sonsdonerkebab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18110259175476997586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sons-dner-kebab",
      "poi_latitude": "32.4339853",
      "poi_longitude": "-81.7802216",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-681-7835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR6iDmLNA-ogR0q2QkMSQVPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_48642bfa-a70f-4315-92a8-3b0db2d5c45d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Coconut Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "520 Fair Rd #140, Statesboro, GA 30458, USA",
      "poi_short_description": "Basic eatery serving traditional Thai noodle dishes, fried rice selections & red or green curries.",
      "poi_long_description": "Basic eatery serving traditional Thai noodle dishes, fried rice selections & red or green curries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c156-73bf-b2fa-76dad74aa826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c156-73bf-b2fa-76dad74aa826",
        "storage_key": "property/6737460151191773/019e1e1a-c156-73bf-b2fa-76dad74aa826.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://coconutthaicuisine.net/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7178432520421834405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coconut-thai-cuisine",
      "poi_latitude": "32.4340926",
      "poi_longitude": "-81.7799139",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-512-5128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA1NIorNA-ogRpf7aJ1jqnmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_3d34ef10-ae60-4b5b-aa26-7743c59ba9e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "El Rinconcito",
      "poi_type": "Restaurants",
      "poi_address": "2 College Plaza, Statesboro, GA 30458, USA",
      "poi_short_description": "Informal, family-owned eatery serving traditional Mexican fare such as fajitas, enchiladas and tacos, plus a salsa bar featuring different salsas and toppings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c108-7359-ba3c-70b453a58fe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c108-7359-ba3c-70b453a58fe5",
        "storage_key": "property/6737460151191773/019e1e1a-c108-7359-ba3c-70b453a58fe5.webp",
        "width": 1153,
        "height": 1280
      },
      "poi_business_url": "https://www.elrinconcitostatesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10478786547050211577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rinconcito",
      "poi_latitude": "32.4352066",
      "poi_longitude": "-81.78068379999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-871-5502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWdFG7NA-ogR-egRdtggbJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3aade0a2-b321-45cb-8189-ef35929774e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Ocean Galley Seafood",
      "poi_type": "Restaurants",
      "poi_address": "15 Coach Lee Hl Blvd, Statesboro, GA 30458, USA",
      "poi_short_description": "Spacious, informal seafood restaurant in a shopping plaza also offering steaks & burgers.",
      "poi_long_description": "Spacious, informal seafood restaurant in a shopping plaza also offering steaks & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c415-72da-a20d-97ba7a1454f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c415-72da-a20d-97ba7a1454f0",
        "storage_key": "property/6737460151191773/019e1e1a-c415-72da-a20d-97ba7a1454f0.webp",
        "width": 1280,
        "height": 987
      },
      "poi_business_url": "https://oceangalleys.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16406862687723035499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocean-galley-seafood",
      "poi_latitude": "32.4406539",
      "poi_longitude": "-81.7626241",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-489-4145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6c6e6005ee2f",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6c6e6005ee2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3IUhas4-ogRa5tX7K_isOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a7f30a19-c84e-4cc0-8143-3f9154eadb9d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Mill Creek Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6696254764061082663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-food-mart",
      "poi_latitude": "32.450305",
      "poi_longitude": "-81.76061899999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-764-5967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e76-71f1-aebb-1feabdb8de23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e76-71f1-aebb-1feabdb8de23",
        "storage_key": "property/6737460151191773/019e1e1b-1e76-71f1-aebb-1feabdb8de23.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJb9BWc6c4-ogRJ8RgyTrg7Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_82a00278-de68-470b-8e37-d7e34a873359",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "555 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c3b1-752b-a270-b15b33e97e8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c3b1-752b-a270-b15b33e97e8e",
        "storage_key": "property/6737460151191773/019e1e1a-c3b1-752b-a270-b15b33e97e8e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ga/statesboro/3375",
      "poi_directions_map_url": "https://maps.google.com/?cid=2792321692022198042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "32.4548862",
      "poi_longitude": "-81.752524",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 912-290-2320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8776-70d2-b9cd-4e27156e9404",
        "storage_key": "property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKfjLoE9H-ogRGs-Z18hRwCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0332c503-c949-4419-9997-278809bada80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "The Statesboro Mainstreet Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "222 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Saturday markets featuring produce, baked goods, meats, eggs and flowers, as well as other items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c858-76b2-9510-03f27e78cc3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c858-76b2-9510-03f27e78cc3b",
        "storage_key": "property/6737460151191773/019e1e1a-c858-76b2-9510-03f27e78cc3b.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.visitstatesboro.org/farmers-market",
      "poi_directions_map_url": "https://maps.google.com/?cid=17927945389295946646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-statesboro-mainstreet-farmers-market",
      "poi_latitude": "32.4440783",
      "poi_longitude": "-81.78284819999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-259-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8776-70d2-b9cd-4e27156e9404",
        "storage_key": "property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHQPjFKpA-ogRlkuWYVjbzPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_2e4236ed-4d37-448b-830a-829620ef538e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "441 Fair Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-c552-7459-9d83-34d7b2e70c43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-c552-7459-9d83-34d7b2e70c43",
        "storage_key": "property/6737460151191773/019e1e1a-c552-7459-9d83-34d7b2e70c43.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/statesboro-ga-pharmacies/441-fair-rd-statesboro-ga-30458/storeid=6861?WT.mc_id=LS_GOOGLE_RX_6861",
      "poi_directions_map_url": "https://maps.google.com/?cid=6557906658189383436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.4348432",
      "poi_longitude": "-81.783214",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-489-0943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e7d-7090-9cf7-4ef841b92009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e7d-7090-9cf7-4ef841b92009",
        "storage_key": "property/6737460151191773/019e1e1b-1e7d-7090-9cf7-4ef841b92009.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70cZxLNA-ogRDBeMP1xdAls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_19e0c666-fcd0-4c0d-9919-a15e3d4b3b2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "613 Northside Dr E, Statesboro, GA 30458, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d41e-7503-9701-bfb877832699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d41e-7503-9701-bfb877832699",
        "storage_key": "property/6737460151191773/019e1e1a-d41e-7503-9701-bfb877832699.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-613+northside+dr+e-statesboro-ga-30458/id=9257",
      "poi_directions_map_url": "https://maps.google.com/?cid=17546920111676631443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.4395822",
      "poi_longitude": "-81.76526439999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-489-3008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUkUQQ1H-ogRk6mkvt8ug_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_74e9975e-2959-4b3f-9394-2c4b495fa7f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "325 Northside Dr E # 1, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-cb0c-747d-bece-55944a741ab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-cb0c-747d-bece-55944a741ab6",
        "storage_key": "property/6737460151191773/019e1e1a-cb0c-747d-bece-55944a741ab6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stores.foodlion.com/ga/statesboro/325-northside-dr.-e.?y_source=1_MjI1NjA4NTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10812123011003316610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.4372327",
      "poi_longitude": "-81.76307930000002",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-489-1465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8785-775b-99ab-960c80529ac9",
        "storage_key": "property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfKGL4xH-ogRgvmt6pdgDJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5308f3ed-f5dc-481b-bbac-608c066a3398",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "349 Brampton Ave, Statesboro, GA 30458, USA",
      "poi_short_description": "Neighborhood grocery store providing a wide range of items, including produce, and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-54ad-774b-95b0-195e1752cd62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-54ad-774b-95b0-195e1752cd62",
        "storage_key": "property/6737460151191773/019e1e18-54ad-774b-95b0-195e1752cd62.webp",
        "width": 1280,
        "height": 526
      },
      "poi_business_url": "https://www.walmart.com/store/2858-statesboro-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18325691837167980672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.4116053",
      "poi_longitude": "-81.76849870000001",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-489-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8785-775b-99ab-960c80529ac9",
        "storage_key": "property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnfw6gS9H-ogRgFCs2aHvUf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ab83419d-fd7d-4d9f-a532-0752d6c7e5c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Publix Super Market at Eagles Corner Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Tormenta Wy, Statesboro, GA 30458, USA",
      "poi_short_description": "Clean grocery store that offers a range of produce alongside baked goods and prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-4e7e-72dd-9939-7cedc97cbfc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-4e7e-72dd-9939-7cedc97cbfc4",
        "storage_key": "property/6737460151191773/019e1e18-4e7e-72dd-9939-7cedc97cbfc4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=4095611296680667969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-eagles-corner-shopping-center",
      "poi_latitude": "32.4116613",
      "poi_longitude": "-81.7945692",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-681-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8785-775b-99ab-960c80529ac9",
        "storage_key": "property/6737460151191773/019e1e18-8785-775b-99ab-960c80529ac9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMx9id0FB-ogRQWu6XMaI1jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9aa07acd-1612-4b1d-92eb-7cf847c4a0fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Mirror On Main Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "65 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-cf77-75d4-9e78-b4a396e16db8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-cf77-75d4-9e78-b4a396e16db8",
        "storage_key": "property/6737460151191773/019e1e1a-cf77-75d4-9e78-b4a396e16db8.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.mirroronmain.com/collections/new-arrivals?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4756072696150548209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mirror-on-main-boutique",
      "poi_latitude": "32.448959",
      "poi_longitude": "-81.78066989999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-723-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8776-70d2-b9cd-4e27156e9404",
        "storage_key": "property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKRL8a-9B-ogR8d78G-v2AEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_52300f7a-e737-4d73-9689-8f24051a26b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Mill Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "239 Beasley Rd, Statesboro, GA 30461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mces.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17583012415567640383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-elementary-school",
      "poi_latitude": "32.4531618",
      "poi_longitude": "-81.7462078",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-212-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSWF2W4M4-ogRPzcxF6JoA_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d7af3878-27df-4026-8ad0-ffdcf5f37f19",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Sallie Zetterower Elementary School",
      "poi_type": "Education",
      "poi_address": "1200 Cawana Rd, Statesboro, GA 30461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d021-71c7-825a-8ee9964417c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d021-71c7-825a-8ee9964417c0",
        "storage_key": "property/6737460151191773/019e1e1a-d021-71c7-825a-8ee9964417c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://szes.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6576389600309544884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sallie-zetterower-elementary-school",
      "poi_latitude": "32.419457",
      "poi_longitude": "-81.7528731",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-212-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyZpVxVFH-ogRtAcGj38HRFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_734a5697-9885-424a-8d13-d7f85a63605d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro High School",
      "poi_type": "Education",
      "poi_address": "10 Coach Lee Hl Blvd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-cfd0-738b-91ea-f8f0711f450d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-cfd0-738b-91ea-f8f0711f450d",
        "storage_key": "property/6737460151191773/019e1e1a-cfd0-738b-91ea-f8f0711f450d.webp",
        "width": 1280,
        "height": 1137
      },
      "poi_business_url": "https://shs.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4444774818788004453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-high-school",
      "poi_latitude": "32.4436178",
      "poi_longitude": "-81.7629788",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 912-212-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFZcvS1lH-ogRZdJ19CUDrz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1b90bbe4-98f0-4341-acf5-c72ffbdb4a28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "William James Middle School",
      "poi_type": "Education",
      "poi_address": "18809 US-80, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-cfc3-73dd-9c41-4f1a47d2d0e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-cfc3-73dd-9c41-4f1a47d2d0e3",
        "storage_key": "property/6737460151191773/019e1e1a-cfc3-73dd-9c41-4f1a47d2d0e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wjms.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13287687307966895645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-james-middle-school",
      "poi_latitude": "32.4900803",
      "poi_longitude": "-81.81354929999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-212-8820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ69O9aSA--ogRHVbVlTRZZ7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3c7d67f1-f973-4de7-a8b4-0d1f63dbe0fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Mattie Lively Elementary School",
      "poi_type": "Education",
      "poi_address": "204 Debbie Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d344-76e7-83fa-bf93af2dc6d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d344-76e7-83fa-bf93af2dc6d3",
        "storage_key": "property/6737460151191773/019e1e1a-d344-76e7-83fa-bf93af2dc6d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mles.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6407694535530364806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattie-lively-elementary-school",
      "poi_latitude": "32.4694131",
      "poi_longitude": "-81.7866789",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-212-8760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8S0DtAj-xQRhr9_Czu07Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ec21d85b-633a-4763-9c8d-13a52c5a8cd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bulloch Academy",
      "poi_type": "Education",
      "poi_address": "873 Westside Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d794-74e9-a939-cb65772440d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d794-74e9-a939-cb65772440d0",
        "storage_key": "property/6737460151191773/019e1e1a-d794-74e9-a939-cb65772440d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bullochacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11039142772455858914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulloch-academy",
      "poi_latitude": "32.447743",
      "poi_longitude": "-81.81303199999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-764-6297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VkT639A-ogR4mINGd3pMpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f485345b-f5d0-4416-9f64-b734b68ad4ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Georgia Southern University",
      "poi_type": "Education",
      "poi_address": "1332 Southern Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-59a9-73fd-bfda-25ae374816aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-59a9-73fd-bfda-25ae374816aa",
        "storage_key": "property/6737460151191773/019e1e18-59a9-73fd-bfda-25ae374816aa.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.georgiasouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9173345002236955828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university",
      "poi_latitude": "32.4206845",
      "poi_longitude": "-81.7869734",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH5neYdFA-ogRtExwVK1ETn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1553159b-c510-4b8a-bbc5-6c46c72a6c4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Ogeechee Technical College",
      "poi_type": "Education",
      "poi_address": "1 Joe Kennedy Blvd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-5894-7108-831e-e54b757bff49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-5894-7108-831e-e54b757bff49",
        "storage_key": "property/6737460151191773/019e1e18-5894-7108-831e-e54b757bff49.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ogeecheetech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694898559551195813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ogeechee-technical-college",
      "poi_latitude": "32.394824",
      "poi_longitude": "-81.818542",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-681-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs78u8QhB-ogRpcribpPpa5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d33e1e2b-fbee-44ee-b104-2e5702b76942",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Georgia Southern University Child Development Center",
      "poi_type": "Education",
      "poi_address": "789 Forest Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://chhs.georgiasouthern.edu/she/cdc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=928231427085791082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-child-development-center",
      "poi_latitude": "32.4263281",
      "poi_longitude": "-81.7867761",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-478-5537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVeCIeugh-xQRam_NoJC94Qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a5306f1d-da6a-4c67-a3eb-bd3d7f9aa06a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro First United Methodist Church",
      "poi_type": "Education",
      "poi_address": "101 S Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-dc3f-766b-887c-ac1c020c8ea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-dc3f-766b-887c-ac1c020c8ea6",
        "storage_key": "property/6737460151191773/019e1e1a-dc3f-766b-887c-ac1c020c8ea6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.statesborofirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3864600580350200413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-first-united-methodist-church",
      "poi_latitude": "32.4470977",
      "poi_longitude": "-81.7843017",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-7589",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1ead-75da-9df6-412f74bba6ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1ead-75da-9df6-412f74bba6ad",
        "storage_key": "property/6737460151191773/019e1e1b-1ead-75da-9df6-412f74bba6ad.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1vQf6lA-ogRXcqKlsDRoTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_4715e130-7226-405f-b48e-7b8cf02a0fb3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Averitt Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "33 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Venue with a restored, landmark exterior for touring professional shows as well as community plays.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d861-7178-8c25-02d0dd7819d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d861-7178-8c25-02d0dd7819d8",
        "storage_key": "property/6737460151191773/019e1e1a-d861-7178-8c25-02d0dd7819d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.averittcenterforthearts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16637180388958421112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "averitt-center-for-the-arts",
      "poi_latitude": "32.4490177",
      "poi_longitude": "-81.782517",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-212-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8x8ybKpA-ogReED2i2oj4-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bf3f64da-1617-4005-a03b-a7b58b83e96f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "AMC CLASSIC Statesboro 12",
      "poi_type": "Entertainment",
      "poi_address": "610 Brannen St, Statesboro, GA 30458, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d728-755d-8fec-69550ddef2c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d728-755d-8fec-69550ddef2c3",
        "storage_key": "property/6737460151191773/019e1e1a-d728-755d-8fec-69550ddef2c3.webp",
        "width": 1280,
        "height": 991
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/savannah-ga/amc-classic-statesboro-12?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5333312039781498246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-statesboro-12",
      "poi_latitude": "32.4340901",
      "poi_longitude": "-81.76358929999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-489-4322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1eae-76db-b5e1-06b12f343317.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1eae-76db-b5e1-06b12f343317",
        "storage_key": "property/6737460151191773/019e1e1b-1eae-76db-b5e1-06b12f343317.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RZroyZH-ogRhn19Bwu7A0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7729016d-b1ea-4f3a-84de-29ad230dc386",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Georgia Southern Museum",
      "poi_type": "Entertainment",
      "poi_address": "2142 Southern Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "University museum devoted to the region's natural history, featuring prehistoric & modern fossils.",
      "poi_long_description": "University museum devoted to the region's natural history, featuring prehistoric & modern fossils.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-62a6-7663-bc15-86de99e75fe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-62a6-7663-bc15-86de99e75fe5",
        "storage_key": "property/6737460151191773/019e1e18-62a6-7663-bc15-86de99e75fe5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.georgiasouthern.edu/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=4540045068565767518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-museum",
      "poi_latitude": "32.4272658",
      "poi_longitude": "-81.781809",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-478-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8779-7456-aa06-787258ac3d3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8779-7456-aa06-787258ac3d3a",
        "storage_key": "property/6737460151191773/019e1e18-8779-7456-aa06-787258ac3d3a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTBt_8tA-ogRXmUgiO96AT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_83d27437-ecd3-4399-ba1a-afa60c334b01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Botanic Garden at Georgia Southern University",
      "poi_type": "Entertainment",
      "poi_address": "1503 Bland Ave, Statesboro, GA 30458, USA",
      "poi_short_description": "Garden featuring native Georgia trees & plants, wooded walking paths & hands-on exhibits.",
      "poi_long_description": "Garden featuring native Georgia trees & plants, wooded walking paths & hands-on exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-743a-739a-9086-434b579ecdf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-743a-739a-9086-434b579ecdf4",
        "storage_key": "property/6737460151191773/019e1e18-743a-739a-9086-434b579ecdf4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/visit/botanic-garden",
      "poi_directions_map_url": "https://maps.google.com/?cid=3835476494954115132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "botanic-garden-at-georgia-southern-university",
      "poi_latitude": "32.4207435",
      "poi_longitude": "-81.773876",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-478-1149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzX1hbjRH-ogRPLAZCo1ZOjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_0bd7ba04-654d-4f49-8a5c-b420ec68482e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Splash in the Boro Waterpark - Statesboro, Bulloch County",
      "poi_type": "Entertainment",
      "poi_address": "1388 Georgia Hwy 24, Statesboro, GA 30461, USA",
      "poi_short_description": "Family waterpark with many slides & pools, a lazy river, swim lessons & a dome for winter swimming.",
      "poi_long_description": "Family waterpark with many slides & pools, a lazy river, swim lessons & a dome for winter swimming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-6b51-744d-baa6-263d617e8118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-6b51-744d-baa6-263d617e8118",
        "storage_key": "property/6737460151191773/019e1e18-6b51-744d-baa6-263d617e8118.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://splashintheboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17582587634446913472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "splash-in-the-boro-waterpark---statesboro-bulloch-county",
      "poi_latitude": "32.4508808",
      "poi_longitude": "-81.7380427",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-489-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxFG6IQ4-ogRwE9iB0zmAfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_84697921-68fe-4817-8165-6895b74a1dc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Eagle Creek Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "106 Savannah Ave B, Statesboro, GA 30458, USA",
      "poi_short_description": "Casual microbrewery and restaurant serving brisket, burgers, and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-d9a7-74cf-b00f-bd4bd9d4e11d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-d9a7-74cf-b00f-bd4bd9d4e11d",
        "storage_key": "property/6737460151191773/019e1e1a-d9a7-74cf-b00f-bd4bd9d4e11d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.eaglecreekbrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11822457806072150916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-creek-brewing-company",
      "poi_latitude": "32.448084",
      "poi_longitude": "-81.77989079999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-489-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e87-70ac-8b78-778e9c24e050.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e87-70ac-8b78-778e9c24e050",
        "storage_key": "property/6737460151191773/019e1e1b-1e87-70ac-8b78-778e9c24e050.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8ePlapA-ogRhHv5jrzOEaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_e33a4ed6-00ae-4938-ae0a-e5a5fb0d7747",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "The Blue Room",
      "poi_type": "Entertainment",
      "poi_address": "1830 Chandler Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "Live-music venue attracting college students with a restaurant and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-dac1-75be-808b-d74dfe5f4bcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-dac1-75be-808b-d74dfe5f4bcc",
        "storage_key": "property/6737460151191773/019e1e1a-dac1-75be-808b-d74dfe5f4bcc.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://www.facebook.com/blueroomboro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11785654508487776574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-blue-room",
      "poi_latitude": "32.4142836",
      "poi_longitude": "-81.78390089999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yNGMYZB-ogRPhnlF1UOj6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_8db41b5d-c0a9-4909-ab24-43b58d694d45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Gators & Gypsies",
      "poi_type": "Entertainment",
      "poi_address": "19 E Vine St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-de44-73b9-84ea-c636aed406c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-de44-73b9-84ea-c636aed406c9",
        "storage_key": "property/6737460151191773/019e1e1a-de44-73b9-84ea-c636aed406c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5780350288240594697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gators--gypsies",
      "poi_latitude": "32.4480324",
      "poi_longitude": "-81.78225839999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 833-882-5117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx49RsUhB-ogRCU_oJ_btN1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_01cbece3-ed63-4fc6-a5e5-4c64075a2ac2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Boro The Hatchet Axe Throwing",
      "poi_type": "Entertainment",
      "poi_address": "19 E Vine St, Statesboro, GA 30458, USA",
      "poi_short_description": "Recreational venue where visitors can try their hand at ax throwing in a safe environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-de45-720e-b36d-9155698a97ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-de45-720e-b36d-9155698a97ea",
        "storage_key": "property/6737460151191773/019e1e1a-de45-720e-b36d-9155698a97ea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://borothehatchet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14382575076023296757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boro-the-hatchet-axe-throwing",
      "poi_latitude": "32.448223",
      "poi_longitude": "-81.7822508",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-515-5246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_HHeyRH-ogR9WLBWdQrmcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_17a12983-febd-4b66-8bf1-7ffbb6d59730",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Galactic Comics & Games",
      "poi_type": "Entertainment",
      "poi_address": "21 E Vine St, Statesboro, GA 30458, USA",
      "poi_short_description": "Store that specializes in comics and games including board and tabletop versions, plus graphic novels, toys and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e033-75a7-ad45-fffe537a17c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e033-75a7-ad45-fffe537a17c1",
        "storage_key": "property/6737460151191773/019e1e1a-e033-75a7-ad45-fffe537a17c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://galacticcg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9595076928688219169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "galactic-comics--games",
      "poi_latitude": "32.4480209",
      "poi_longitude": "-81.7820974",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-489-3123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8776-70d2-b9cd-4e27156e9404",
        "storage_key": "property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxbI-i1U_-ogRIeQBN6GPKIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e6b46dd7-0c0f-4196-a515-55a5384b7026",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "East Georgia Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1499 Fair Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-7063-74fa-bb78-b8c62b2effb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-7063-74fa-bb78-b8c62b2effb3",
        "storage_key": "property/6737460151191773/019e1e18-7063-74fa-bb78-b8c62b2effb3.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.eastgeorgiaregional.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2144745839827578410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-georgia-regional-medical-center",
      "poi_latitude": "32.4144463",
      "poi_longitude": "-81.7701848",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-486-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87bc-714b-8250-b2128f3af6e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87bc-714b-8250-b2128f3af6e5",
        "storage_key": "property/6737460151191773/019e1e18-87bc-714b-8250-b2128f3af6e5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8R4YCVH-ogRKm5rXPqqwx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d9312922-bd7a-43b8-a064-e5884c59fbac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Peachtree Immediate Care - Statesboro",
      "poi_type": "Health and Wellness",
      "poi_address": "586 Brannen St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e3be-7775-a35a-3e03735e96c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e3be-7775-a35a-3e03735e96c3",
        "storage_key": "property/6737460151191773/019e1e1a-e3be-7775-a35a-3e03735e96c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.peachtreemed.com/location/statesboro-urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12545265824583365511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---statesboro",
      "poi_latitude": "32.4349436",
      "poi_longitude": "-81.7694096",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-871-6611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9pUSk5H-ogRh7Mjv8y8Ga4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c11b832f-6399-458a-be55-aeb916d5a11e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "ExperCARE Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "121 Tormenta Wy, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e54a-7502-a3f7-07aeb7a5e5c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e54a-7502-a3f7-07aeb7a5e5c4",
        "storage_key": "property/6737460151191773/019e1e1a-e54a-7502-a3f7-07aeb7a5e5c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://expercarehealth.com/locations/statesboro/?utm_source=google+business+profile&utm_medium=organic&utm_campaign=gbp&utm_content=statesboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=4837418997760061510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expercare-urgent-care--primary-care",
      "poi_latitude": "32.4110128",
      "poi_longitude": "-81.79467629999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-680-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUpixHVB-ogRRvA23_L2IUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_32927b8c-0a51-4d77-9c0b-9ff432fb999e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Publix Pharmacy at Eagles Corner Shopping Center",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Tormenta Wy, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e53b-705b-bb1b-fc8d91283de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e53b-705b-bb1b-fc8d91283de5",
        "storage_key": "property/6737460151191773/019e1e1a-e53b-705b-bb1b-fc8d91283de5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=16656475559444289424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-eagles-corner-shopping-center",
      "poi_latitude": "32.4105128",
      "poi_longitude": "-81.79310129999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-243-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1e7d-7090-9cf7-4ef841b92009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1e7d-7090-9cf7-4ef841b92009",
        "storage_key": "property/6737460151191773/019e1e1b-1e7d-7090-9cf7-4ef841b92009.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwusFqpA-ogRkBengkWwJ-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_532edf89-a331-45e3-995e-b5a85d0870ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "430 Northside Dr E, Statesboro, GA 30458, USA",
      "poi_short_description": "Chain gym with tanning and spa services offering plenty of machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-6374-72da-bee5-5eeace947095.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-6374-72da-bee5-5eeace947095",
        "storage_key": "property/6737460151191773/019e1e18-6374-72da-bee5-5eeace947095.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/statesboro-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2060387782439399280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.4405616",
      "poi_longitude": "-81.7605901",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-521-8430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cpY1xtH-ogRcO_aj8X3lxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_61be3932-dae2-4004-a8f0-a329a49adf40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "FIT Statesboro",
      "poi_type": "Health and Wellness",
      "poi_address": "107 W Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "Members-only fitness center with a variety of machines, a powerlifting room, and personal training services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e79a-72b7-b300-fb80d5355b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e79a-72b7-b300-fb80d5355b68",
        "storage_key": "property/6737460151191773/019e1e1a-e79a-72b7-b300-fb80d5355b68.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://www.fitstatesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13920900390469438802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-statesboro",
      "poi_latitude": "32.449453",
      "poi_longitude": "-81.786376",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-481-6085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYs10KlA-ogRUg2HJyb5MME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_501b316e-f250-4a91-b1df-fba230b3debd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "HOTWORX- Statesboro, GA - University Station",
      "poi_type": "Health and Wellness",
      "poi_address": "237 Tormenta Wy, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-e66e-760e-80d8-422ec44f1b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-e66e-760e-80d8-422ec44f1b68",
        "storage_key": "property/6737460151191773/019e1e1a-e66e-760e-80d8-422ec44f1b68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hotworx.net/studio/statesboro-university-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7779339963296221100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx--statesboro-ga---university-station",
      "poi_latitude": "32.4110093",
      "poi_longitude": "-81.7924589",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-512-3442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoziJkoZB-ogRrIdF23rE9Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_47bd10a2-a02b-4a58-bb48-8d93a04caafb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Fusion Training",
      "poi_type": "Health and Wellness",
      "poi_address": "1263 S&S Railroad Bed Trail Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-eb23-75b4-b373-1b6255502ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-eb23-75b4-b373-1b6255502ee5",
        "storage_key": "property/6737460151191773/019e1e1a-eb23-75b4-b373-1b6255502ee5.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://www.trainedbyfusion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14557000307654504550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fusion-training",
      "poi_latitude": "32.4215579",
      "poi_longitude": "-81.74761769999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-349-9660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1D7aoY4-ogRZrD_TKfaBMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86d9e759-c585-4541-8dac-849c4bbc960e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro City Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-eac1-7338-a92b-b8d2ab450528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-eac1-7338-a92b-b8d2ab450528",
        "storage_key": "property/6737460151191773/019e1e1a-eac1-7338-a92b-b8d2ab450528.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://statesborodowntown.com/downtown-dog-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17794827472590463925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-city-dog-park",
      "poi_latitude": "32.4457822",
      "poi_longitude": "-81.7814336",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-7227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZPiWdJB-ogRteMdJ07t8_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_97b12e41-e491-44a4-b797-114c94e1afc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Blind Willie McTell Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "433 Fair Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-eb79-7420-956d-df706006d140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-eb79-7420-956d-df706006d140",
        "storage_key": "property/6737460151191773/019e1e1a-eb79-7420-956d-df706006d140.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=559395456164690359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blind-willie-mctell-trail",
      "poi_latitude": "32.4353983",
      "poi_longitude": "-81.78272640000002",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiU7y-M9B-ogRt_mpHTRfwwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5d00d5c8-db03-4815-bb06-e13a6778eba6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bulloch County Recreation and Parks",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Max Lockwood Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "Kids' playground with swings and picnic tables, plus a clean field for soccer and other sports.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-eba1-7605-a652-af41745ab432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-eba1-7605-a652-af41745ab432",
        "storage_key": "property/6737460151191773/019e1e1a-eba1-7605-a652-af41745ab432.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.bullochrec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11213952217161350278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulloch-county-recreation-and-parks",
      "poi_latitude": "32.437523",
      "poi_longitude": "-81.783225",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-764-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9g4G7JA-ogRhjwboCD2n5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ac956986-c536-42f5-b2a2-147cff8243a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "The S&S Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Gentilly Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "Paved trail meandering past wetlands and woods for walking, running, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-7f40-7614-92ed-036e7ec375a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-7f40-7614-92ed-036e7ec375a1",
        "storage_key": "property/6737460151191773/019e1e18-7f40-7614-92ed-036e7ec375a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.visitstatesboro.org/things-to-do/ss-greenway-walking-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=12848281631271798450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ss-greenway",
      "poi_latitude": "32.4327335",
      "poi_longitude": "-81.7700386",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVMSL09H-ogRssYhDhJETrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51a24c78-08c9-4faa-bff7-4e7ad3aab56d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Pretoria Station Trailhead: Statesboro-Bulloch County Parks & Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S&S, Railroad Bed Rd, Statesboro, GA 30461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f04c-70ab-9850-51e11afd248a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f04c-70ab-9850-51e11afd248a",
        "storage_key": "property/6737460151191773/019e1e1a-f04c-70ab-9850-51e11afd248a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bullochrec.com/facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12164201336500451201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pretoria-station-trailhead-statesboro-bulloch-county-parks--recreation",
      "poi_latitude": "32.4117317",
      "poi_longitude": "-81.7320648",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR62EhZFH-ogRgfdwtqrsz6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5dc99863-3fde-471f-bb3c-b0b7df7c5d5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Mill Creek Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1388 Georgia Hwy 24, Statesboro, GA 30461, USA",
      "poi_short_description": "Parkland with baseball/soccer fields, tennis courts, playgrounds, exercise stations & a water park.",
      "poi_long_description": "Parkland with baseball/soccer fields, tennis courts, playgrounds, exercise stations & a water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-72ce-76f4-856e-bf9f7b0b087d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-72ce-76f4-856e-bf9f7b0b087d",
        "storage_key": "property/6737460151191773/019e1e18-72ce-76f4-856e-bf9f7b0b087d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bullochrec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743839846499200394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-regional-park",
      "poi_latitude": "32.4551743",
      "poi_longitude": "-81.7382811",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-764-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyVEsYY4-ogRiq0li80TFCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b4c3c3f-867f-4ae0-b3ca-a390aee95d9f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Luetta Moore Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "585 Martin Luther King Jr Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "Modern park featuring a playground slides and swings plus a public pool and a volleyball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-7e09-779a-a3f7-73990c4561ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-7e09-779a-a3f7-73990c4561ac",
        "storage_key": "property/6737460151191773/019e1e18-7e09-779a-a3f7-73990c4561ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitstatesboro.org/things-to-do/luetta-moore-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10947489783423515015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luetta-moore-park",
      "poi_latitude": "32.4529376",
      "poi_longitude": "-81.79039929999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9eH1lk_-ogRhzktq_RL7Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fb40c598-883f-46eb-a556-e8ac1b7445c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Fletcher memorial park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "707 Lakeview Rd, Statesboro, GA 30461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f794-7239-a3c3-b61ecbaed94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f794-7239-a3c3-b61ecbaed94b",
        "storage_key": "property/6737460151191773/019e1e1a-f794-7239-a3c3-b61ecbaed94b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitstatesboro.org/things-to-do/fletcher-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10843196102811613189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fletcher-memorial-park",
      "poi_latitude": "32.473053",
      "poi_longitude": "-81.7829749",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-764-5637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6SZaAA_-ogRBXj84WfFepY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_03ab8d34-9262-4307-a26a-969da3874fb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Reverend W.D. Kent Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "107 W Grady St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f493-755e-821c-bce61c0a36a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f493-755e-821c-bce61c0a36a2",
        "storage_key": "property/6737460151191773/019e1e1a-f493-755e-821c-bce61c0a36a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7134354278928950709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reverend-wd-kent-park",
      "poi_latitude": "32.446033",
      "poi_longitude": "-81.79189",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c6-713a-9f61-6ffa91bdf968",
        "storage_key": "property/6737460151191773/019e1e18-87c6-713a-9f61-6ffa91bdf968.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWyxy_hlB-ogRtSVZ0WpRAmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f147e903-9e5f-49e2-8b52-8eaeaa7321cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Russell Union",
      "poi_type": "Transportation & Transit",
      "poi_address": "85 Georgia Ave, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f2e8-762f-98b7-8aabbbb24717.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f2e8-762f-98b7-8aabbbb24717",
        "storage_key": "property/6737460151191773/019e1e1a-f2e8-762f-98b7-8aabbbb24717.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://students.georgiasouthern.edu/union/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4416241016131351282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russell-union",
      "poi_latitude": "32.4249786",
      "poi_longitude": "-81.7797071",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-478-0441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXpu28pA-ogR8vIEUc6jST0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_8860d612-14b9-4368-a401-995e81e14ada",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Parking & Transportation/Georgia Southern University",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dorman Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f553-762b-9959-893b32e18ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f553-762b-9959-893b32e18ed3",
        "storage_key": "property/6737460151191773/019e1e1a-f553-762b-9959-893b32e18ed3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://auxiliary.georgiasouthern.edu/parking/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856263963208328495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking--transportationgeorgia-southern-university",
      "poi_latitude": "32.4238636",
      "poi_longitude": "-81.7776447",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-478-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU4tOQDVH-ogRLyVAJ8R67ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_31d69a53-6a81-41b4-b622-f012da921e5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Allen E. Paulson Stadium",
      "poi_type": "Transportation & Transit",
      "poi_address": "203 Lanier Dr, Statesboro, GA 30458, USA",
      "poi_short_description": "Stadium (nicknamed “The Prettiest Little Stadium in America”) for Georgia Southern football games, hosting graduations alongside other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-5f20-738c-a677-be56602045c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-5f20-738c-a677-be56602045c4",
        "storage_key": "property/6737460151191773/019e1e18-5f20-738c-a677-be56602045c4.webp",
        "width": 510,
        "height": 566
      },
      "poi_business_url": "http://gseagles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3611906258838453456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allen-e-paulson-stadium",
      "poi_latitude": "32.4121952",
      "poi_longitude": "-81.7831353",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-478-9467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87c3-7759-a078-14332833be18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87c3-7759-a078-14332833be18",
        "storage_key": "property/6737460151191773/019e1e18-87c3-7759-a078-14332833be18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtQaTaNFA-ogR0HwTEJsRIDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ebebab64-9637-48dd-9d67-93b7749cc8d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "Georgia 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8206945602114722742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-bus-stop",
      "poi_latitude": "32.39709000000001",
      "poi_longitude": "-81.82106999999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDYLi6QdB-ogRtpsA-Yrt5HE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_39513707-57bd-42d6-b6d5-011431151839",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro Bulloch County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Airport Blvd #601, Statesboro, GA 30461, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-7ad6-71ca-9ab7-9acd2115ef50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-7ad6-71ca-9ab7-9acd2115ef50",
        "storage_key": "property/6737460151191773/019e1e18-7ad6-71ca-9ab7-9acd2115ef50.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.statesboroairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11873991691430567654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-bulloch-county-airport",
      "poi_latitude": "32.4806429",
      "poi_longitude": "-81.7417158",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-764-9083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8a09-743f-8cbd-1a53eca14528.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8a09-743f-8cbd-1a53eca14528",
        "storage_key": "property/6737460151191773/019e1e18-8a09-743f-8cbd-1a53eca14528.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3yej3fA4-ogR5p6oQYjkyKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5c9e540c-1e29-46e7-bdf2-19a4e0929126",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1b-1472-7757-810d-f9a8882c95b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1b-1472-7757-810d-f9a8882c95b4",
        "storage_key": "property/6737460151191773/019e1e1b-1472-7757-810d-f9a8882c95b4.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "48.1",
      "poi_walking_minutes": "17 hours 23 mins",
      "poi_biking_minutes": "4 hours 9 mins",
      "poi_driving_minutes": "1 hour 1 min",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8a09-743f-8cbd-1a53eca14528.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8a09-743f-8cbd-1a53eca14528",
        "storage_key": "property/6737460151191773/019e1e18-8a09-743f-8cbd-1a53eca14528.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_48c32dff-0392-4455-898f-2659980b9336",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Enterprise Rent-A-Car",
      "poi_type": "Transportation & Transit",
      "poi_address": "922 Northside Dr E, Statesboro, GA 30458, USA",
      "poi_short_description": "Car rental chain offering a variety of vehicles and a low-touch rental process.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-f883-75af-9778-bf48fd68c1d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-f883-75af-9778-bf48fd68c1d3",
        "storage_key": "property/6737460151191773/019e1e1a-f883-75af-9778-bf48fd68c1d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.enterprise.com/en/car-rental-locations/us/ga/statesboro-2678.html?mcid=yext:245709",
      "poi_directions_map_url": "https://maps.google.com/?cid=5252910214225813059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enterprise-rent-a-car",
      "poi_latitude": "32.4434665",
      "poi_longitude": "-81.767887",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-542-2576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55E_SldH-ogRQ17zOwIW5kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_e0bd2571-a903-4da5-981a-6c5c0cb81769",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bulloch County Brd-Commissioners",
      "poi_type": "Major Employers & Offices",
      "poi_address": "115 N Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-fb76-774f-acef-eb58a22b9089.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-fb76-774f-acef-eb58a22b9089",
        "storage_key": "property/6737460151191773/019e1e1a-fb76-774f-acef-eb58a22b9089.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14853212092888430666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulloch-county-brd-commissioners",
      "poi_latitude": "32.4524842",
      "poi_longitude": "-81.78362469999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-764-6245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-9c1ddb4f4579",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZsZK1Q_-ogRSrgm6rM1Ic4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_76ea5a78-8529-47ce-8d32-dbd4d8ecb837",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "50 E Main St, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-7887-77af-a969-408739a01f15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-7887-77af-a969-408739a01f15",
        "storage_key": "property/6737460151191773/019e1e18-7887-77af-a969-408739a01f15.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.statesboroga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16728467469899129412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-city-hall",
      "poi_latitude": "32.4486567",
      "poi_longitude": "-81.78155540000002",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-764-5468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-9c1ddb4f4579",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCU_PYapA-ogRROIDXIh0J-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_4a1584e7-cf70-4e8a-8b10-b7e843473817",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bulloch County Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 Williams Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-fb95-704a-be8c-918eefda316a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-fb95-704a-be8c-918eefda316a",
        "storage_key": "property/6737460151191773/019e1e1a-fb95-704a-be8c-918eefda316a.webp",
        "width": 1280,
        "height": 650
      },
      "poi_business_url": "http://www.bulloch.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18210309301544652447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulloch-county-schools",
      "poi_latitude": "32.4591739",
      "poi_longitude": "-81.79463559999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-212-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-877a-766e-9d9e-6bd7188470e3",
        "storage_key": "property/6737460151191773/019e1e18-877a-766e-9d9e-6bd7188470e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhfXbTQA_-ogRn46P0NMDuPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_87fe46a4-4b3f-46dd-a36d-17e8c175f6a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Statesboro VA Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "658 Northside Dr E Suite B, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.augusta.va.gov/locations/Statesboro_GA_Telehealth_Clinic.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10523352865244340512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statesboro-va-clinic",
      "poi_latitude": "32.4407588",
      "poi_longitude": "-81.7650677",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-871-8719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfupsltH-ogRIGH6Aq11CpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_27a2fa14-02e6-40a7-89af-bf71492bbdf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Willingway",
      "poi_type": "Major Employers & Offices",
      "poi_address": "311 Jones Mill Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-fb7a-7442-92c2-eb5a4944466f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-fb7a-7442-92c2-eb5a4944466f",
        "storage_key": "property/6737460151191773/019e1e1a-fb7a-7442-92c2-eb5a4944466f.webp",
        "width": 700,
        "height": 393
      },
      "poi_business_url": "https://willingway.com/?utm_source=gmblisting&utm_medium=organic&utm_campaign=webbutton",
      "poi_directions_map_url": "https://maps.google.com/?cid=3305731544188084840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willingway",
      "poi_latitude": "32.4445277",
      "poi_longitude": "-81.75723339999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 888-994-7970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwTYI15H-ogRaGIiLlNR4C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_fff9f93c-de41-4fcd-81c8-d05e8e789c36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Walmart Distribution Center 6061",
      "poi_type": "Major Employers & Offices",
      "poi_address": "299 AJ Riggs Rd, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-fcc2-742c-a53c-ef1fcfbd34e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-fcc2-742c-a53c-ef1fcfbd34e8",
        "storage_key": "property/6737460151191773/019e1e1a-fcc2-742c-a53c-ef1fcfbd34e8.webp",
        "width": 719,
        "height": 1280
      },
      "poi_business_url": "http://www.walmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7045818089730010022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-distribution-center-6061",
      "poi_latitude": "32.3897331",
      "poi_longitude": "-81.8398014",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-871-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-a2752054e65c",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-a2752054e65c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJecHrqbxB-ogRputg5jjGx2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "custom_7b8c96a7-6341-405e-b7f9-df756a4879c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "147 Northside Dr E, Statesboro, GA 30458, USA",
      "poi_short_description": "Friendly, helpful staff, self-service checkout, and a wide selection of grocery items for everyday needs are the hallmarks of this chain discount retailer, which also sells electronics, furniture and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e1a-fdf5-733a-9f19-fe24f5bd04ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1a-fdf5-733a-9f19-fe24f5bd04ba",
        "storage_key": "property/6737460151191773/019e1e1a-fdf5-733a-9f19-fe24f5bd04ba.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/754-statesboro-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4734659081446337202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.4341535",
      "poi_longitude": "-81.7595513",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-489-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-8776-70d2-b9cd-4e27156e9404",
        "storage_key": "property/6737460151191773/019e1e18-8776-70d2-b9cd-4e27156e9404.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4YDnwkJH-ogRsqovalnjtEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2885b47e-9924-4e1d-a545-04d0bbb6e573",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "poi_name": "Bulloch County Sheriff's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17257 US-301, Statesboro, GA 30458, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://bullochsheriff.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9671471453188280697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bulloch-county-sheriffs-office",
      "poi_latitude": "32.4654441",
      "poi_longitude": "-81.7672128",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-764-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-87d6-73ad-9413-9c1ddb4f4579",
        "storage_key": "property/6737460151191773/019e1e18-87d6-73ad-9413-9c1ddb4f4579.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkXP4N7A4-ogReVGehgv4N4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f0e13e8389f1ae4319c6f813",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a24e9ff520bfd1e3fd7bb534",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5742f868a29eb22f5b4a1bff",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_409ffc83bc5f9143cedc6168",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f74d03d900bc0e4cd086ea72",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7d84bd24-97ea-4555-b0e6-abb8be15b8af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "rating": "5",
      "name": "All in All Movers All in All Movers of Georgia",
      "text": ".\n",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_d333b2dc-9443-48e7-83e5-603b464c209f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "rating": "5",
      "name": "jennifer reid",
      "text": "We had such a great experience touring the apartment with Mrs. Angela! She was friendly, informative, and made us feel completely at ease. She explained everything clearly and was very attentive to our needs and questions. Touring with her made us even more excited about the possibility of living here!",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_e5fd8bdd-470a-454c-8263-d846adabb165",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "rating": "5",
      "name": "Shaniya Smith",
      "text": "Ms Angela was so helpful and sweet , Brooklyn was also nice everyone is professional and maintenance come as soon as he can . I love my new spacious place .",
      "date": "2026-02-20",
      "title": "false"
    },
    {
      "id": "custom_ae37abbf-d1cd-4c55-a020-9d252493f20b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "rating": "5",
      "name": "ChaKayla Smith",
      "text": "Brooklyn was so amazing. Any issues me and my sister had she helped us at the moment ! I know I called so many times and she never had an attitude! Very outstanding and professional! She’s great at giving tours! When she was explaining everything she explained it well to the point I didn’t have any questions! We appreciate you for all your hard work!",
      "date": "2026-01-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_58f8525a-7414-460a-8b22-a915ef003a85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019e6780-cc58-779c-84ce-84c7055f9a79.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e6780-cc58-779c-84ce-84c7055f9a79",
        "storage_key": "property/6737460151191773/019e6780-cc58-779c-84ce-84c7055f9a79.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Leasing Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=68a92bb7dc8d9ee51d5c593d"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199400b-ab9c-72ea-b18e-30c6ed46c340",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-village-at-mill-creek-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773"
    },
    {
      "lead_collector_id": "01996475-75c9-71ba-ade6-70e359f96dd3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-village-at-mill-creek-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "apartments-with-pool-statesboro-ga",
      "search_query": "apartments with pool in Statesboro GA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Statesboro GA",
      "h2_subtitle": "Discover relaxing apartments with a pool in Statesboro. Dive into comfort with our amenities designed for leisure and active lifestyles.",
      "page_copy": "Welcome to Village at Mill Creek, where you'll find exceptional apartments with pool in Statesboro GA, designed for both relaxation and enjoyment. Our community proudly features two sparkling pools, perfect for cooling off on a hot Georgia day or enjoying a peaceful swim under the stars. Located in the heart of the Georgia South Area, our residence offers spacious two and three-bedroom floor plans that cater to a variety of lifestyles.\n\nAt Village at Mill Creek, life’s all about balance. Along with our inviting pool areas, residents can take advantage of other amenities like a fully-equipped fitness center, a welcoming dog park, and online services for easy living. Coupled with the charm of Statesboro, you'll experience modern living at its best, making it easy to call our community home. Explore the ultimate blend of leisure and elegance that awaits you here!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Statesboro GA",
      "seo_description": "Discover Village at Mill Creek: Apartments with pool in Statesboro GA, offering spacious floor plans and premium amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "dog-park-apartment-statesboro-ga",
      "search_query": "dog park apartment Statesboro GA",
      "category": "Amenity",
      "h1_title": "Dog Park Apartment in Statesboro GA",
      "h2_subtitle": "Experience dog park apartment living in Statesboro GA. Enjoy pet-friendly amenities designed for you and your furry friends.",
      "page_copy": "At Village at Mill Creek, we understand the importance of pet-friendly living, which is why our dog park apartment in Statesboro GA offers an idyllic setting for you and your furry companions. Nestled in the vibrant Georgia South Area, our community provides ample space for your pets to roam and play freely. Our dedicated dog park is a perfect haven where pets can enjoy social interactions in a safe, welcoming environment.\n\nOur spacious two and three-bedroom floor plans are designed with both you and your pets in mind. Beyond the pet-friendly amenities, Village at Mill Creek offers other exceptional features such as sparkling pools, a state-of-the-art fitness center, and online services to make your life easier. Situated in Statesboro, GA, our community combines convenience with a touch of charm, creating the perfect home for pet lovers. Join us and discover why our residents love calling Village at Mill Creek home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartment in Statesboro GA",
      "seo_description": "Discover pet-friendly living at Village at Mill Creek. Enjoy our dog park apartment in Statesboro GA and exceptional amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-georgia-south-area",
      "search_query": "fitness center apartment Georgia South Area",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartment in Georgia South Area",
      "h2_subtitle": "Discover a fitness center apartment in the Georgia South Area. Stay active with our modern amenities designed just for you.",
      "page_copy": "Welcome to Village at Mill Creek, the premier destination for those seeking a fitness center apartment in the Georgia South Area. Our state-of-the-art fitness center is just one of the many exceptional amenities that make our community special. Whether you're into cardio workouts, strength training, or simply maintaining an active lifestyle, our fitness facilities are equipped to meet all your health goals.\n\nLocated in Statesboro, GA, our two and three-bedroom floor plans offer residents a harmonious blend of comfort and convenience. Apart from our fitness center, you'll enjoy on-site features like sparkling pools for leisure swims, a dedicated dog park for pet play, and online services to simplify your daily routine. Experience the vibrant lifestyle of the Georgia South Area while enjoying modern living at its best at Village at Mill Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartment Georgia South Area",
      "seo_description": "Stay active at Village at Mill Creek, with our fitness center apartment in the Georgia South Area offering modern amenities for a healthy lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-bulloch-county",
      "search_query": "air conditioned apartments Bulloch County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Bulloch County",
      "h2_subtitle": "Enjoy comfort in air conditioned apartments in Bulloch County. Perfectly designed for modern living in a vibrant community.",
      "page_copy": "Discover the ultimate in comfort and style at Village at Mill Creek, where our air conditioned apartments in Bulloch County provide a refreshing oasis from the warm Georgia weather. Located in the charming setting of Statesboro's Georgia South Area, our community offers spacious two and three-bedroom floor plans, ensuring a perfect fit for various lifestyles. Each apartment is thoughtfully equipped with air conditioning, providing you with the comfort needed on warm days.\n\nBeyond cool interiors, Village at Mill Creek features a host of excellent amenities such as sparkling pools, a fully-equipped fitness center, and a fun dog park. All these amenities are designed to enhance your lifestyle and create a serene environment. Enjoy the convenience of online services and more, making life simpler and more enjoyable in our vibrant community. Embrace modern living with stylish comfort at Village at Mill Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Bulloch County",
      "seo_description": "Stay cool at Village at Mill Creek with air conditioned apartments in Bulloch County. Experience modern comfort in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-in-30461",
      "search_query": "apartments with dishwasher in 30461",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in 30461",
      "h2_subtitle": "Discover apartments with dishwasher in 30461. Enjoy modern conveniences in the heart of Statesboro, GA.",
      "page_copy": "At Village at Mill Creek, we offer comfortable living with modern conveniences, including apartments with dishwasher in 30461. Located in Statesboro, GA, our community embraces the perfect blend of functionality and style. Our spacious two and three-bedroom floor plans are equipped with dishwashers, adding ease and convenience to your daily routine, so you can spend more time enjoying what matters most.\n\nResidents at Village at Mill Creek delight in a range of amenities beyond our in-unit dishwashers. Enjoy a relaxing swim in our sparkling pools, keep fit in our state-of-the-art fitness center, and let your pets play freely in our dog park. Situated in the friendly Georgia South Area, our community is designed to meet your living needs with hassle-free online services and additional amenities that elevate your lifestyle. Discover the essence of modern living in Statesboro today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in 30461",
      "seo_description": "Find convenience at Village at Mill Creek with apartments with a dishwasher in 30461. Modern living with great amenities in Statesboro, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-statesboro-ga",
      "search_query": "two bedroom apartments statesboro ga",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Statesboro, GA",
      "h2_subtitle": "Explore spacious two bedroom apartments in Statesboro, GA. Enjoy modern amenities and a vibrant community at Village at Mill Creek.",
      "page_copy": "Experience the best in modern living with our spacious two bedroom apartments in Statesboro, GA at Village at Mill Creek. Perfectly designed for comfort and convenience, these well-appointed apartments offer ample space, allowing you to customize your home to suit your lifestyle. With features like air conditioning, dishwashers, and a balcony, each apartment provides a welcoming and functional living environment.\n\nOur community not only offers comfortable living spaces but also a host of amenities designed to enhance your lifestyle. Dive into relaxation at our sparkling pools, stay energized in our state-of-the-art fitness center, or take your furry friend for a run in our dog park. Situated in the Georgia South Area within Bulloch County, Village at Mill Creek brings together the best elements of convenience and leisure in a vibrant neighborhood setting. Discover your new home in Statesboro, GA today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Statesboro, GA",
      "seo_description": "Discover spacious two bedroom apartments in Statesboro, GA at Village at Mill Creek. Enjoy a host of modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191773",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-bulloch-county",
      "search_query": "three bedroom apartments bulloch county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Bulloch County",
      "h2_subtitle": "Find roomy three bedroom apartments in Bulloch County. Enjoy comfort and convenience at Village at Mill Creek.",
      "page_copy": "Look no further than Village at Mill Creek for spacious three bedroom apartments in Bulloch County. Our accommodations are perfect for families or those seeking ample living space in the heart of the Georgia South Area in Statesboro. Each apartment comes equipped with modern amenities like air conditioning and dishwashers, ensuring a convenient and comfortable lifestyle.\n\nBeyond expansive living spaces, Village at Mill Creek offers a range of community features designed to elevate your living experience. Enjoy resort-style facilities like sparkling pools, a cutting-edge fitness center, and a welcoming dog park. Nestled in Bulloch County, our community provides a balance of leisure and accessibility, creating a serene yet vibrant living environment. Whether you're settling in with family or roommates, our three-bedroom apartments offer a perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d076e-dc15-70e8-a391-91b3e70324b0",
        "storage_key": "property/6737460151191773/019d076e-dc15-70e8-a391-91b3e70324b0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Bulloch County",
      "seo_description": "Discover spacious three bedroom apartments in Bulloch County at Village at Mill Creek. Enjoy modern living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3359"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483213"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026484"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N5PG337Q"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_sh_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=sh"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "409-405-6343"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "409-377-8052"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "409-377-8081"
    },
    {
      "ID": "custom_knock_sh_title",
      "type": "STRING",
      "value": "Student Housing ILS"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "409-405-6129"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "409-377-8098"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "409-235-3839"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "409-407-7154"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "409-407-7093"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "409-377-8051"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "912-420-4460"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_sh_number",
      "type": "STRING",
      "value": "409-297-7786"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "409-402-7715"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "409-405-6320"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "409-916-7144"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "409-908-4193"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "409-547-7527"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "409-509-6298"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "409-345-2280"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "409-215-2396"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321108749"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "409-377-8017"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "409-257-4616"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "dc14fe11ee3d24a5"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "409-359-2534"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "409-377-8085"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "409-405-6497"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "409-407-4386"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "409-377-8023"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "409-377-8014"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "409-405-6319"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "409-377-8056"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.villagemillcreek.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191773/019e84a9-8556-72c9-af0e-5928835c17a7.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "409-377-8024"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "912-420-4460"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3359",
  "custom_repli_id": "5028483213",
  "custom_realpage_id": "5026484",
  "custom_knock_a_link": "https://www.villagemillcreek.com?utm_knock=a",
  "custom_knock_g_link": "https://www.villagemillcreek.com?utm_knock=g",
  "custom_knock_r_link": "https://www.villagemillcreek.com?utm_knock=r",
  "custom_knock_w_link": "https://www.villagemillcreek.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-N5PG337Q",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.villagemillcreek.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.villagemillcreek.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.villagemillcreek.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.villagemillcreek.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.villagemillcreek.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.villagemillcreek.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_sh_link": "https://www.villagemillcreek.com?utm_knock=sh",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "409-405-6343",
  "custom_knock_ads_link": "https://www.villagemillcreek.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.villagemillcreek.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "409-377-8052",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.villagemillcreek.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.villagemillcreek.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.villagemillcreek.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.villagemillcreek.com?utm_knock=psa",
  "custom_knock_r_number": "409-377-8081",
  "custom_knock_sh_title": "Student Housing ILS",
  "custom_knock_w_number": "409-405-6129",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "409-377-8098",
  "custom_knock_amap_link": "https://www.villagemillcreek.com?utm_knock=amap",
  "custom_knock_ar_number": "409-235-3839",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "409-407-7154",
  "custom_knock_fb_number": "409-407-7093",
  "custom_knock_fl_number": "409-377-8051",
  "custom_knock_gp_number": "912-420-4460",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.villagemillcreek.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_sh_number": "409-297-7786",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "409-402-7715",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.villagemillcreek.com?utm_knock=bcard",
  "custom_knock_bnr_number": "409-405-6320",
  "custom_knock_cfres_link": "https://www.villagemillcreek.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "409-916-7144",
  "custom_knock_lgp_number": "409-908-4193",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.villagemillcreek.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "409-547-7527",
  "custom_knock_psa_number": "409-509-6298",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "409-345-2280",
  "custom_knock_bandit_link": "https://www.villagemillcreek.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.villagemillcreek.com?utm_knock=flyers",
  "custom_knock_osoc_number": "409-215-2396",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321108749",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "409-377-8017",
  "custom_knock_cfres_number": "409-257-4616",
  "custom_knock_chatgpt_link": "https://www.villagemillcreek.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "dc14fe11ee3d24a5",
  "custom_knock_dirmail_link": "https://www.villagemillcreek.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "409-359-2534",
  "custom_knock_propbro_link": "https://www.villagemillcreek.com?utm_knock=propbro",
  "custom_knock_bandit_number": "409-377-8085",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "409-405-6497",
  "custom_knock_outbound_link": "https://www.villagemillcreek.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.villagemillcreek.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "409-407-4386",
  "custom_knock_dirmail_number": "409-377-8023",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "409-377-8014",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "409-405-6319",
  "custom_knock_revcards_number": "409-377-8056",
  "custom_knock_maintenance_link": "https://www.villagemillcreek.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191773/019e84a9-8556-72c9-af0e-5928835c17a7.mp4",
  "custom_knock_maintenance_number": "409-377-8024",
  "custom_ppc_tracking_phone_number": "912-420-4460",
  "custom_audioeye_site_id": "56b71308-2f8f-4f96-b1e2-47fdc6c83a3e",
  "custom_audioeye_site_hash": "0325438c30771edd6451bed779a6d858"
};

export const generatedAt = '2026-10-27T16:19:54.202Z';
